webpackJsonp([10],{

/***/ 1523:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Devices_vue__ = __webpack_require__(1863);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01e0f042_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Devices_vue__ = __webpack_require__(2192);
function injectStyle (ssrContext) {
  __webpack_require__(2188)
  __webpack_require__(2190)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01e0f042"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Devices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01e0f042_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Devices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Otwarte modale w kolejności otwierania. Esc zamyka tylko ostatni, żeby przy
// zagnieżdżonych modalach (np. wykres otwierany z modala szczegółów alarmów)
// nie zamykały się wszystkie naraz.
var openModals = [];

// Esc w otwartej liście vue-select / vue-multiselect zamyka samą listę; przy
// otwartym kalendarzu vue2-datepicker też nie ruszamy modala, żeby jednym
// klawiszem nie stracić wypełnionego formularza.
var OPEN_DROPDOWN = '.vs--open, .multiselect--active';
var OPEN_DATEPICKER = '.mx-datepicker-popup';

// Faza capture: sprawdzamy listy, zanim ich własna obsługa Esc je zamknie.
function onDocumentKeydown(event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;

    var topModal = openModals[openModals.length - 1];
    if (topModal == null) return;

    var target = event.target;
    if (target instanceof Element && target.closest(OPEN_DROPDOWN) != null) return;
    if (document.querySelector(OPEN_DATEPICKER) != null) return;

    topModal.$emit('close');
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Modal',
    props: {
        showDialog: {
            type: Boolean,
            required: false,
            default: false
        },
        maxWidth: {
            type: String,
            required: false,
            default: ''
        },
        title: {
            type: String,
            required: false,
            default: ''
        }
    },
    watch: {
        showDialog: {
            immediate: true,
            handler: function handler(isOpen) {
                isOpen ? this.registerOpen() : this.unregisterOpen();
            }
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.unregisterOpen();
    },

    computed: {
        style: function style() {
            return 'max-width: ' + this.maxWidth;
        }
    },
    methods: {
        registerOpen: function registerOpen() {
            if (openModals.includes(this)) return;
            openModals.push(this);
            if (openModals.length === 1) {
                document.addEventListener('keydown', onDocumentKeydown, true);
            }
        },
        unregisterOpen: function unregisterOpen() {
            var index = openModals.indexOf(this);
            if (index === -1) return;
            openModals.splice(index, 1);
            if (openModals.length === 0) {
                document.removeEventListener('keydown', onDocumentKeydown, true);
            }
        }
    }
});

/***/ }),

/***/ 1547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(1545);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330662f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(1550);
function injectStyle (ssrContext) {
  __webpack_require__(1548)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-330662f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330662f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1548:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1549);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("6de141c4", content, true, {});

/***/ }),

/***/ 1549:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".modal[data-v-330662f6]{position:fixed;z-index:110;left:0;top:0;width:100%;height:100%;overflow:auto;display:block;background-color:rgba(0,0,0,.4)}.flex-container[data-v-330662f6]{height:100%;padding:0;margin:0;display:-webkit-box;display:-ms-flexbox;display:flex}.modal-content[data-v-330662f6]{margin:auto;background-color:#fefefe;border:unset;width:auto;z-index:1000;border-radius:5px;-webkit-box-shadow:0 4px 10px rgba(0,0,0,.2);box-shadow:0 4px 10px rgba(0,0,0,.2)}.modal-header[data-v-330662f6]{background-color:#34758e;width:100%;font-family:SourceSansProBold,sans-serif;font-size:16px;font-style:normal;font-weight:600;color:#fff}.close[data-v-330662f6]{color:#fff;float:right;font-size:28px;font-weight:700}.close[data-v-330662f6]:focus,.close[data-v-330662f6]:hover{color:#000;text-decoration:none;cursor:pointer}.widthClass[data-v-330662f6]{max-width:30%}#mdiv[data-v-330662f6]{width:25px;height:25px;cursor:pointer}.mdiv[data-v-330662f6]{height:25px;width:2px;margin-left:12px;background-color:#fff;-webkit-transform:rotate(45deg);transform:rotate(45deg);Z-index:1}.md[data-v-330662f6]{height:25px;width:2px;background-color:#fff;-webkit-transform:rotate(90deg);transform:rotate(90deg);Z-index:2}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Modal.vue"],"names":[],"mappings":"AACA,wBACI,eAAgB,AAGhB,YAAa,AACb,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,YAAa,AACb,cAAe,AACf,cAAe,AACf,+BAAkC,CACrC,AACD,iCACI,YAAa,AACb,UAAW,AACX,SAAU,AACV,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACjB,AAKD,gCACI,YAAa,AACb,yBAA0B,AAC1B,aAAc,AACd,WAAY,AACZ,aAAc,AACd,kBAAmB,AACnB,6CAAiD,AACzC,oCAAyC,CACpD,AACD,+BACI,yBAA2B,AAC3B,WAAY,AACZ,yCAA6C,AAC7C,eAAgB,AAChB,kBAAmB,AACnB,gBAAiB,AACjB,UAAa,CAChB,AACD,wBACI,WAAa,AACb,YAAa,AACb,eAAgB,AAChB,eAAkB,CACrB,AACD,4DAEI,WAAa,AACb,qBAAsB,AACtB,cAAgB,CACnB,AACD,6BACI,aAAe,CAClB,AAKD,uBACE,WAAY,AACZ,YAAa,AACb,cAAgB,CACjB,AACD,uBACE,YAAa,AACb,UAAW,AACX,iBAAkB,AAClB,sBAAwB,AACxB,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACZ,AACD,qBACE,YAAa,AACb,UAAW,AACX,sBAAwB,AACxB,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACZ","file":"Modal.vue","sourcesContent":["\n.modal[data-v-330662f6] {\n    position: fixed;\n    /* Nad paskiem górnym (.app-header, z-index 20) i mobilnym menu (99/100),\n       ale pod popupami doklejanymi do body (Syncfusion 1000, datepicker 2001). */\n    z-index: 110;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    display: block;\n    background-color: rgba(0,0,0,0.4);\n}\n.flex-container[data-v-330662f6] {\n    height: 100%;\n    padding: 0;\n    margin: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n/* margin: auto zamiast align-items/justify-content: center — modal wyższy od\n   ekranu zaczyna się od góry i da się go przewinąć do nagłówka z krzyżykiem\n   (przy centrowaniu flexem jego górna część wystawała poza ekran). */\n.modal-content[data-v-330662f6] {\n    margin: auto;\n    background-color: #fefefe;\n    border: unset;\n    width: auto;\n    z-index: 1000;\n    border-radius: 5px;\n    -webkit-box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n            box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n}\n.modal-header[data-v-330662f6] {\n    background-color:  #34758E;\n    width: 100%;\n    font-family: \"SourceSansProBold\", sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    color: white;\n}\n.close[data-v-330662f6] {\n    color: white;\n    float: right;\n    font-size: 28px;\n    font-weight: bold;\n}\n.close[data-v-330662f6]:hover,\n.close[data-v-330662f6]:focus {\n    color: black;\n    text-decoration: none;\n    cursor: pointer;\n}\n.widthClass[data-v-330662f6] {\n    max-width: 30%;\n}\n.modal-slot[data-v-330662f6] {\n    /* margin-right: 10px;\n    margin-left: 10px; */\n}\n#mdiv[data-v-330662f6] {\n  width: 25px;\n  height: 25px;\n  cursor: pointer;\n}\n.mdiv[data-v-330662f6] {\n  height: 25px;\n  width: 2px;\n  margin-left: 12px;\n  background-color: white;\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n  Z-index: 1;\n}\n.md[data-v-330662f6] {\n  height: 25px;\n  width: 2px;\n  background-color: white;\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n  Z-index: 2;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDialog)?_c('div',{staticClass:"modal flex-container"},[_c('div',{staticClass:"modal-content vertical",style:(_vm.style)},[_c('div',{staticClass:"modal-header"},[(_vm.title != undefined)?_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title != null ? _vm.title : '')+" ")]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"mdiv"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"modal-slot"},[_vm._t("default")],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdiv"},[_c('div',{staticClass:"md"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1554:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(1562);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ 1555:
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ 1557:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1559), __esModule: true };

/***/ }),

/***/ 1558:
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 1559:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1560);
module.exports = __webpack_require__(105).Object.assign;


/***/ }),

/***/ 1560:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(183);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1561) });


/***/ }),

/***/ 1561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(154);
var getKeys = __webpack_require__(955);
var gOPS = __webpack_require__(1558);
var pIE = __webpack_require__(1555);
var toObject = __webpack_require__(954);
var IObject = __webpack_require__(959);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(442)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ 1562:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1564), __esModule: true };

/***/ }),

/***/ 1563:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createChartTheme */
/* unused harmony export chartTooltipColors */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return chartThemeMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scichart_Charting_Themes_SciChartJSLightTheme__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scichart_Charting_Themes_SciChartJSLightTheme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_scichart_Charting_Themes_SciChartJSLightTheme__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scichart_Charting_Themes_SciChartJSDarkv2Theme__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scichart_Charting_Themes_SciChartJSDarkv2Theme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_scichart_Charting_Themes_SciChartJSDarkv2Theme__);



// Wykresy rysują na canvasie, więc tokeny CSS z theme.css do nich nie sięgają —
// motyw SciChart dobieramy osobno, z tego samego rozwiązanego motywu aplikacji.

// Tło jak --surface ciemnego motywu, zamiast grafitowego gradientu paczki,
// żeby wykres nie odcinał się od karty, w której stoi.
var DARK_BACKGROUND = "#172124";

function createChartTheme(resolvedTheme) {
    if (resolvedTheme !== "dark") return new __WEBPACK_IMPORTED_MODULE_0_scichart_Charting_Themes_SciChartJSLightTheme__["SciChartJSLightTheme"]();

    var theme = new __WEBPACK_IMPORTED_MODULE_1_scichart_Charting_Themes_SciChartJSDarkv2Theme__["SciChartJSDarkv2Theme"]();
    theme.sciChartBackground = DARK_BACKGROUND;
    theme.loadingAnimationBackground = DARK_BACKGROUND;
    return theme;
}

// Dymki rollovera rysowane własnym szablonem SVG mają kolory wpisane w SVG,
// więc applyTheme ich nie zmienia. Jasne to dotychczasowy biały dymek z czarnym
// tekstem, ciemne — kolory wysuwanych paneli z theme.css (--popover-*).
var TOOLTIP_COLORS = {
    light: { background: "#ffffff", border: "#000000", text: "#000000" },
    dark: { background: "#1b2629", border: "#50676d", text: "#e8f1f3" }
};

function chartTooltipColors(resolvedTheme) {
    return resolvedTheme === "dark" ? TOOLTIP_COLORS.dark : TOOLTIP_COLORS.light;
}

// Wykres woła this.chartTheme() przy tworzeniu powierzchni, a mixin
// przemalowuje już narysowane wykresy, gdy użytkownik zmieni motyw.
// Wymaga, żeby komponent trzymał powierzchnię w this.sciChartSurface.
var chartThemeMixin = {
    watch: {
        "$store.getters.resolvedTheme": function $storeGettersResolvedTheme() {
            if (this.sciChartSurface) this.sciChartSurface.applyTheme(this.chartTheme());
        }
    },
    methods: {
        chartTheme: function chartTheme() {
            return createChartTheme(this.$store.getters.resolvedTheme);
        },

        // Szablon dymka woła to przy każdym rysowaniu, więc zmiana motywu działa od razu.
        tooltipColors: function tooltipColors() {
            return chartTooltipColors(this.$store.getters.resolvedTheme);
        }
    }
};

/***/ }),

/***/ 1564:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(957);
__webpack_require__(1565);
module.exports = __webpack_require__(105).Array.from;


/***/ }),

/***/ 1565:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(221);
var $export = __webpack_require__(183);
var toObject = __webpack_require__(954);
var call = __webpack_require__(965);
var isArrayIter = __webpack_require__(966);
var toLength = __webpack_require__(445);
var createProperty = __webpack_require__(1566);
var getIterFn = __webpack_require__(963);

$export($export.S + $export.F * !__webpack_require__(967)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ 1566:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(184);
var createDesc = __webpack_require__(447);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ 1569:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNSAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNSAxLjVDNC4xODYyOSAxLjUgMS41IDQuMTg2MjkgMS41IDcuNUMxLjUgMTAuODEzNyA0LjE4NjI5IDEzLjUgNy41IDEzLjVDMTAuODEzNyAxMy41IDEzLjUgMTAuODEzNyAxMy41IDcuNUMxMy41IDQuMTg2MjkgMTAuODEzNyAxLjUgNy41IDEuNVpNMCA3LjVDMCAzLjM1Nzg2IDMuMzU3ODYgMCA3LjUgMEMxMS42NDIxIDAgMTUgMy4zNTc4NiAxNSA3LjVDMTUgMTEuNjQyMSAxMS42NDIxIDE1IDcuNSAxNUMzLjM1Nzg2IDE1IDAgMTEuNjQyMSAwIDcuNVpNMTAuOTk4MyA1LjA2NDQ0QzExLjMwNzkgNS4zMzk2MyAxMS4zMzU3IDUuODEzNjkgMTEuMDYwNiA2LjEyMzI3TDcuMDYwNTYgMTAuNjIzM0M2LjkxODIzIDEwLjc4MzQgNi43MTQyMyAxMC44NzUgNi41IDEwLjg3NUM2LjI4NTc3IDEwLjg3NSA2LjA4MTc3IDEwLjc4MzQgNS45Mzk0NCAxMC42MjMzTDMuOTM5NDQgOC4zNzMyN0MzLjY2NDI1IDguMDYzNjkgMy42OTIxNCA3LjU4OTYzIDQuMDAxNzMgNy4zMTQ0NEM0LjMxMTMxIDcuMDM5MjUgNC43ODUzNyA3LjA2NzE0IDUuMDYwNTYgNy4zNzY3M0w2LjUgOC45OTYxTDkuOTM5NDQgNS4xMjY3M0MxMC4yMTQ2IDQuODE3MTQgMTAuNjg4NyA0Ljc4OTI1IDEwLjk5ODMgNS4wNjQ0NFoiIGZpbGw9IiMxRUNENzQiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ 1570:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNSAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNSA4LjM1ODUxQzcuMDk5NjUgOC4zNTg1MSA2Ljc3NTExIDguMDQyNzkgNi43NzUxMSA3LjY1MzMyVjUuNTM3NzZDNi43NzUxMSA1LjE0ODMgNy4wOTk2NSA0LjgzMjU4IDcuNSA0LjgzMjU4QzcuOTAwMzUgNC44MzI1OCA4LjIyNDg5IDUuMTQ4MyA4LjIyNDg5IDUuNTM3NzZWNy42NTMzMkM4LjIyNDg5IDguMDQyNzkgNy45MDAzNSA4LjM1ODUxIDcuNSA4LjM1ODUxWiIgZmlsbD0iI0ZGQjgwMCIvPgo8cGF0aCBkPSJNNi40MTI2NiAxMC4xMjE1QzYuNDEyNjYgOS41MzcyOCA2Ljg5OTQ4IDkuMDYzNjkgNy41IDkuMDYzNjlDOC4xMDA1MiA5LjA2MzY5IDguNTg3MzQgOS41MzcyOCA4LjU4NzM0IDEwLjEyMTVDOC41ODczNCAxMC43MDU3IDguMTAwNTIgMTEuMTc5MyA3LjUgMTEuMTc5M0M2Ljg5OTQ4IDExLjE3OTMgNi40MTI2NiAxMC43MDU3IDYuNDEyNjYgMTAuMTIxNVoiIGZpbGw9IiNGRkI4MDAiLz4KPHBhdGggZD0iTTYuMjE3MDYgMC43NTM0OTdDNi43NjA2IC0wLjI1MTE2MiA4LjIzOTQgLTAuMjUxMTY5IDguNzgyOTQgMC43NTM0OTZMMTQuODMxMiAxMS45MzI3QzE1LjMzOTMgMTIuODcxOSAxNC42MzkyIDE0IDEzLjU0ODIgMTRIMS40NTE3NkMwLjM2MDc4MyAxNCAtMC4zMzkzIDEyLjg3MTkgMC4xNjg4MTkgMTEuOTMyOEw2LjIxNzA2IDAuNzUzNDk3Wk0xMy41NDgyIDEyLjU4OTZMNy41IDEuNDEwMzdMMS40NTE3NiAxMi41ODk2TDEzLjU0ODIgMTIuNTg5NloiIGZpbGw9IiNGRkI4MDAiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ 1571:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNSAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNSAxLjVDNC4xODYyOSAxLjUgMS41IDQuMTg2MjkgMS41IDcuNUMxLjUgMTAuODEzNyA0LjE4NjI5IDEzLjUgNy41IDEzLjVDMTAuODEzNyAxMy41IDEzLjUgMTAuODEzNyAxMy41IDcuNUMxMy41IDQuMTg2MjkgMTAuODEzNyAxLjUgNy41IDEuNVpNMCA3LjVDMCAzLjM1Nzg2IDMuMzU3ODYgMCA3LjUgMEMxMS42NDIxIDAgMTUgMy4zNTc4NiAxNSA3LjVDMTUgMTEuNjQyMSAxMS42NDIxIDE1IDcuNSAxNUMzLjM1Nzg2IDE1IDAgMTEuNjQyMSAwIDcuNVpNNC4zNDQ2NyA0LjM0NDY3QzQuNjM3NTYgNC4wNTE3OCA1LjExMjQ0IDQuMDUxNzggNS40MDUzMyA0LjM0NDY3TDcuNSA2LjQzOTM0TDkuNTk0NjcgNC4zNDQ2N0M5Ljg4NzU2IDQuMDUxNzggMTAuMzYyNCA0LjA1MTc4IDEwLjY1NTMgNC4zNDQ2N0MxMC45NDgyIDQuNjM3NTYgMTAuOTQ4MiA1LjExMjQ0IDEwLjY1NTMgNS40MDUzM0w4LjU2MDY2IDcuNUwxMC42NTUzIDkuNTk0NjdDMTAuOTQ4MiA5Ljg4NzU2IDEwLjk0ODIgMTAuMzYyNCAxMC42NTUzIDEwLjY1NTNDMTAuMzYyNCAxMC45NDgyIDkuODg3NTYgMTAuOTQ4MiA5LjU5NDY3IDEwLjY1NTNMNy41IDguNTYwNjZMNS40MDUzMyAxMC42NTUzQzUuMTEyNDQgMTAuOTQ4MiA0LjYzNzU2IDEwLjk0ODIgNC4zNDQ2NyAxMC42NTUzQzQuMDUxNzggMTAuMzYyNCA0LjA1MTc4IDkuODg3NTYgNC4zNDQ2NyA5LjU5NDY3TDYuNDM5MzQgNy41TDQuMzQ0NjcgNS40MDUzM0M0LjA1MTc4IDUuMTEyNDQgNC4wNTE3OCA0LjYzNzU2IDQuMzQ0NjcgNC4zNDQ2N1oiIGZpbGw9IiNGRjM3MzciLz4KPC9zdmc+Cg=="

/***/ }),

/***/ 1572:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1557);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ 1578:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1579), __esModule: true };

/***/ }),

/***/ 1579:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1580);
module.exports = __webpack_require__(105).Object.keys;


/***/ }),

/***/ 1580:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(954);
var $keys = __webpack_require__(955);

__webpack_require__(1581)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ 1581:
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(183);
var core = __webpack_require__(105);
var fails = __webpack_require__(442);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ 1598:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modal_vue__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SciChart_vue__ = __webpack_require__(1610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SciChartMultiple_vue__ = __webpack_require__(1616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Charts_SciChartOneLineAlarms_vue__ = __webpack_require__(1634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Charts_AlarmDayTimeline_vue__ = __webpack_require__(1611);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_5__Modal_vue__["a" /* default */],
        SciChart: __WEBPACK_IMPORTED_MODULE_6__SciChart_vue__["a" /* default */],
        SciChartMultiple: __WEBPACK_IMPORTED_MODULE_7__SciChartMultiple_vue__["a" /* default */],
        SciChartOneLineAlarms: __WEBPACK_IMPORTED_MODULE_8__Charts_SciChartOneLineAlarms_vue__["a" /* default */],
        AlarmDayTimeline: __WEBPACK_IMPORTED_MODULE_9__Charts_AlarmDayTimeline_vue__["a" /* default */]
    },
    provide: {
        grid: [__WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["l" /* Sort */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["i" /* Page */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["g" /* Filter */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["m" /* Toolbar */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["k" /* Search */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["b" /* CommandColumn */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["j" /* PdfExport */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["f" /* ExcelExport */]]
    },
    props: {
        data: {
            type: Object,
            required: true
        },
        day: {
            type: Number,
            required: false,
            default: 0
        },
        apiMethodName: {
            type: String,
            required: true
        },
        value: {
            type: Number
        }
    },
    data: function data() {
        return {
            obj: [],
            // Oś czasu alarmów dnia (kafelki High/Mid/Low w liście systemów).
            timelineAlarms: null,
            visibleAlarms: [],
            selectedAlarmId: null,
            pendingGridSelection: null,
            filterMenu: {
                type: "Menu"
            },
            pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
            wrapSettings: { wrapMode: "Content" },
            selectionOptions: { type: "Multiple" },
            filterOptions: {
                type: "CheckBox"
            },
            dateTimeFormatOptions: { format: 'yyyy-MM-dd HH:mm:ss', type: 'dateTime' },
            customAttributes: { class: "customcss" }
        };
    },

    methods: {
        getData: function getData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var field, i;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                field = _this.data.column.field;
                                _context.t0 = _this.apiMethodName;
                                _context.next = _context.t0 === 'getSystemAlarmFromToday' ? 4 : _context.t0 === 'getAlarmsByIdAndDay' ? 8 : _context.t0 === 'getAlarmsForDetailsModal' ? 12 : _context.t0 === 'getDeviceAlarmFromDay' ? 16 : _context.t0 === 'getVisitsForDay' ? 20 : 22;
                                break;

                            case 4:
                                _context.next = 6;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_66" /* getSystemAlarmFromDay */])(_this.data.id, field.charAt(field.length - 1), _this.day);

                            case 6:
                                _this.obj = _context.sent;
                                return _context.abrupt('break', 22);

                            case 8:
                                _context.next = 10;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["X" /* getAlarmsByIdAndDay */])(_this.data.id, _this.day);

                            case 10:
                                _this.obj = _context.sent;
                                return _context.abrupt('break', 22);

                            case 12:
                                _context.next = 14;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["Y" /* getAlarmsForDetailsModal */])(_this.data.alarmTypeId, _this.data.systemId, _this.data.deviceId, _this.day);

                            case 14:
                                _this.obj = _context.sent;
                                return _context.abrupt('break', 22);

                            case 16:
                                _context.next = 18;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_23" /* getDeviceAlarmFromDay */])(_this.data.id, field, _this.day);

                            case 18:
                                _this.obj = _context.sent;
                                return _context.abrupt('break', 22);

                            case 20:
                                _this.obj = _this.data[_this.data.column.field][_this.day];
                                return _context.abrupt('break', 22);

                            case 22:

                                for (i = 0; i < _this.obj.length; i++) {
                                    _this.obj[i]['createDate'] = new Date(_this.obj[i]['createDate'].toDateTime());
                                    // 0001-01-01 (brak końca) JS czyta jako rok 2001, więc tabela pokazywała 2001-01-01.
                                    _this.obj[i]['endDate'] = _this.obj[i]['endDate'].indexOf('0001-01-01') === 0 ? null : new Date(_this.obj[i]['endDate'].toDateTime());
                                    _this.obj[i]['alarmType'] = _this.$t(_this.obj[i]['alarmType']);
                                }

                                // Oś czasu dostaje listę dopiero po zamianie dat i tłumaczeniu typów.
                                if (_this.isDayTimeline) {
                                    _this.timelineAlarms = _this.apiMethodName == 'getAlarmsForDetailsModal'
                                    // Tu wszystkie alarmy są jednego typu, a pole alarmType niesie opis
                                    // konkretnego alarmu: legenda dostaje nazwę typu, opis idzie do dymka.
                                    ? _this.obj.map(function (a) {
                                        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, a, { alarmType: _this.data.alarmType, alarmTypeId: _this.data.alarmTypeId, description: a.alarmType });
                                    }) : _this.obj.slice();
                                }

                            case 24:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        dataBound: function dataBound() {
            var _this2 = this;

            var grid = this.$refs.system_modal_grid;
            grid.autoFitColumns();

            if (this.pendingGridSelection != null) {
                var pageIndex = grid.getCurrentViewRecords().findIndex(function (r) {
                    return r.id == _this2.pendingGridSelection;
                });
                this.pendingGridSelection = null;
                if (pageIndex !== -1) grid.selectRow(pageIndex);
            }
        },
        // Oś czasu może pracować na kopiach wierszy, więc tabela bierze oryginały po id.
        onTimelineVisibleChange: function onTimelineVisibleChange(list) {
            var ids = {};
            list.forEach(function (a) {
                ids[a.id] = true;
            });
            this.visibleAlarms = this.obj.filter(function (a) {
                return ids[a.id];
            });
        },
        rowSelected: function rowSelected(args) {
            if (!this.isDayTimeline || args.data == null || Array.isArray(args.data)) return;
            this.selectedAlarmId = args.data.id;
        },

        // Klik w pasek na osi czasu zaznacza wiersz w tabeli, w razie potrzeby na innej stronie.
        selectAlarmInGrid: function selectAlarmInGrid(id) {
            this.selectedAlarmId = id;
            var grid = this.$refs.system_modal_grid;
            if (grid == null) return;

            var pageIndex = grid.getCurrentViewRecords().findIndex(function (r) {
                return r.id == id;
            });
            if (pageIndex !== -1) {
                grid.selectRow(pageIndex);
                return;
            }

            var index = this.visibleAlarms.findIndex(function (a) {
                return a.id == id;
            });
            if (index === -1) return;
            this.pendingGridSelection = id;
            grid.goToPage(Math.floor(index / grid.ej2Instances.pageSettings.pageSize) + 1);
        }
    },
    computed: {
        isDayTimeline: function isDayTimeline() {
            return this.apiMethodName == 'getSystemAlarmFromToday' || this.apiMethodName == 'getAlarmsForDetailsModal';
        }
    },
    mounted: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            this.getData();

                        case 1:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function mounted() {
            return _ref.apply(this, arguments);
        }

        return mounted;
    }()
});

/***/ }),

/***/ 1599:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scichart_Charting_Visuals_SciChartSurface__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scichart_Charting_Visuals_SciChartSurface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_scichart_Charting_Visuals_SciChartSurface__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_Axis_NumericAxis__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_Axis_NumericAxis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_Axis_NumericAxis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scichart_types_AxisAlignment__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scichart_types_AxisAlignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_scichart_types_AxisAlignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Model_XyDataSeries__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Model_XyDataSeries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Model_XyDataSeries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_ChartModifiers_ZoomPanModifier__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_ChartModifiers_ZoomPanModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_scichart_Charting_ChartModifiers_ZoomPanModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_MouseWheelZoomModifier__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_MouseWheelZoomModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_MouseWheelZoomModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_ZoomExtentsModifier__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_ZoomExtentsModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_ZoomExtentsModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_scichart_Charting_ChartModifiers_RolloverModifier__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_scichart_Charting_ChartModifiers_RolloverModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_scichart_Charting_ChartModifiers_RolloverModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_chartTheme__ = __webpack_require__(1563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_scichart_Charting_Drawing_WebGlRenderContext2D__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_scichart_Charting_Drawing_WebGlRenderContext2D___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_scichart_Charting_Drawing_WebGlRenderContext2D__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_scichart_Core_NumberRange__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_scichart_Core_NumberRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_scichart_Core_NumberRange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_scichart_types_XyDirection__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_scichart_types_XyDirection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_scichart_types_XyDirection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_scichart_Charting_ChartModifiers_CursorModifier__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_scichart_Charting_ChartModifiers_CursorModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_scichart_Charting_ChartModifiers_CursorModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_moment__);


//
//
//
//
//
//
//
//



















/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_13__utils_chartTheme__["a" /* chartThemeMixin */]],
    props: ['data', 'labelX', 'labelY', 'sid', 'zoom', 'pan', 'showValues', 'mouseZoom', 'initialZoomOut'],
    data: function data() {
        return {
            sciChartSurface: null,
            wasmContext: null,
            xAxis: null,
            yAxis: null
        };
    },

    watch: {
        chartData: function chartData(newVal, oldVal) {
            this.redraw();
        }
    },
    computed: {
        chartData: function chartData() {
            return this.data;
        }
    },
    methods: {
        initSciChart: function initSciChart() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var xValues, yValues, _ref, sciChartSurface, wasmContext, xAxis, yAxis, d, lineSeries, i, rolloverModifier;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                xValues = _this.data.xValues;
                                yValues = _this.data.yValues;
                                _context.next = 4;
                                return __WEBPACK_IMPORTED_MODULE_2_scichart_Charting_Visuals_SciChartSurface__["SciChartSurface"].create("scichart-root-" + _this.sid);

                            case 4:
                                _ref = _context.sent;
                                sciChartSurface = _ref.sciChartSurface;
                                wasmContext = _ref.wasmContext;


                                _this.sciChartSurface = sciChartSurface;
                                _this.wasmContext = wasmContext;

                                _context.next = 11;
                                return sciChartSurface.applyTheme(_this.chartTheme());

                            case 11:
                                xAxis = new __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_Axis_NumericAxis__["NumericAxis"](_this.wasmContext, { axisAlignment: __WEBPACK_IMPORTED_MODULE_4_scichart_types_AxisAlignment__["EAxisAlignment"].Top });
                                yAxis = new __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_Axis_NumericAxis__["NumericAxis"](_this.wasmContext, { axisAlignment: __WEBPACK_IMPORTED_MODULE_4_scichart_types_AxisAlignment__["EAxisAlignment"].Left });

                                _this.xAxis = xAxis;
                                _this.yAxis = yAxis;

                                if (_this.initialZoomOut == true) {
                                    yAxis.growBy = new __WEBPACK_IMPORTED_MODULE_15_scichart_Core_NumberRange__["NumberRange"](0.1, 0.1);
                                    xAxis.growBy = new __WEBPACK_IMPORTED_MODULE_15_scichart_Core_NumberRange__["NumberRange"](0.1, 0.1);
                                }

                                sciChartSurface.xAxes.add(_this.xAxis);
                                sciChartSurface.yAxes.add(_this.yAxis);

                                xAxis.labelProvider.formatLabel = function (unixTimestamp) {
                                    return __WEBPACK_IMPORTED_MODULE_18_moment___default()(unixTimestamp).format("YYYY-MM-DD, HH:mm:ss");
                                };

                                d = [];
                                lineSeries = new __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__["FastLineRenderableSeries"](_this.wasmContext, {
                                    stroke: "#0095B2",
                                    drawNaNAs: __WEBPACK_IMPORTED_MODULE_14_scichart_Charting_Drawing_WebGlRenderContext2D__["ELineDrawMode"].DiscontinuousLine,
                                    strokeThickness: 2,
                                    pointMarker: new __WEBPACK_IMPORTED_MODULE_12_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker__["EllipsePointMarker"](wasmContext, {
                                        width: 6,
                                        height: 6,
                                        strokeThickness: 2,
                                        fill: "#0095B230",
                                        stroke: "#0095B2"
                                    })
                                });


                                if (!(xValues == undefined || xValues == null || xValues.length == 0)) {
                                    for (i = 0; i < xValues.length; i++) {
                                        d[i] = new Date(__WEBPACK_IMPORTED_MODULE_18_moment___default()(xValues[i])).getTime();
                                    }

                                    lineSeries.dataSeries = new __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](_this.wasmContext, {
                                        xValues: d,
                                        yValues: yValues
                                    });

                                    lineSeries.strokeThickness = 3;
                                    lineSeries.rolloverModifierProps.tooltipLabelX = _this.labelX ? _this.labelX : "X";
                                    lineSeries.rolloverModifierProps.tooltipLabelY = _this.labelY ? _this.labelY : "Y";
                                } else {
                                    d = {};

                                    lineSeries.dataSeries = new __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](_this.wasmContext, {
                                        xValues: {},
                                        yValues: {}
                                    });
                                }

                                _this.sciChartSurface.renderableSeries.add(lineSeries);

                                if (_this.zoomBySelection == true) sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier__["RubberBandXyZoomModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_16_scichart_types_XyDirection__["EXyDirection"].XDirection }));
                                if (_this.pan != false) sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_ChartModifiers_ZoomPanModifier__["ZoomPanModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_16_scichart_types_XyDirection__["EXyDirection"].XDirection }));
                                if (_this.zoom != false) sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_ZoomExtentsModifier__["ZoomExtentsModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_16_scichart_types_XyDirection__["EXyDirection"].XDirection }));
                                if (_this.mouseZoom != false) sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_MouseWheelZoomModifier__["MouseWheelZoomModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_16_scichart_types_XyDirection__["EXyDirection"].XDirection }));

                                rolloverModifier = new __WEBPACK_IMPORTED_MODULE_11_scichart_Charting_ChartModifiers_RolloverModifier__["RolloverModifier"]();

                                rolloverModifier.showRolloverLine = false;
                                _this.sciChartSurface.chartModifiers.add(rolloverModifier);

                                _this.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_17_scichart_Charting_ChartModifiers_CursorModifier__["CursorModifier"]({
                                    crosshairStroke: "#0095B2",
                                    crosshairStrokeThickness: 1,
                                    tooltipContainerBackground: "#000",
                                    tooltipTextStroke: "#0095B2",
                                    showTooltip: false,
                                    axisLabelFill: "#0095B2",
                                    axisLabelStroke: "#fff"
                                }));

                                _this.sciChartSurface.zoomExtents();

                            case 32:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        redraw: function redraw() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var dataSeries, _lineSeries, xValues, yValues, d, i, lineSeries;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(_this2.sciChartSurface == null)) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt("return");

                            case 2:

                                _this2.sciChartSurface.renderableSeries.items = [];

                                if (_this2.data.length == 0) {
                                    dataSeries = new __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](_this2.wasmContext, {
                                        xValues: {},
                                        yValues: {}
                                    });
                                    _lineSeries = new __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__["FastLineRenderableSeries"](_this2.wasmContext, {
                                        dataSeries: dataSeries
                                    });


                                    _this2.sciChartSurface.renderableSeries.add(_lineSeries);
                                }

                                xValues = _this2.data.xValues;
                                yValues = _this2.data.yValues;

                                // Create an X,Y Axis and add to the chart

                                _this2.xAxis = new __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_Axis_NumericAxis__["NumericAxis"](_this2.wasmContext, { axisAlignment: __WEBPACK_IMPORTED_MODULE_4_scichart_types_AxisAlignment__["EAxisAlignment"].Top });
                                _this2.yAxis = new __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_Axis_NumericAxis__["NumericAxis"](_this2.wasmContext, { axisAlignment: __WEBPACK_IMPORTED_MODULE_4_scichart_types_AxisAlignment__["EAxisAlignment"].Left });

                                _this2.xAxis.labelProvider.formatLabel = function (unixTimestamp) {
                                    return __WEBPACK_IMPORTED_MODULE_18_moment___default()(unixTimestamp).format("DD MMM, HH:mm");
                                };

                                d = [];

                                for (i = 0; i < xValues.length; i++) {
                                    d[i] = new Date(__WEBPACK_IMPORTED_MODULE_18_moment___default()(xValues[i])).getTime();
                                }

                                lineSeries = new __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__["FastLineRenderableSeries"](_this2.wasmContext, {
                                    stroke: "#0095B2",
                                    drawNaNAs: __WEBPACK_IMPORTED_MODULE_14_scichart_Charting_Drawing_WebGlRenderContext2D__["ELineDrawMode"].DiscontinuousLine,
                                    strokeThickness: 2,
                                    pointMarker: new __WEBPACK_IMPORTED_MODULE_12_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker__["EllipsePointMarker"](_this2.wasmContext, {
                                        width: 6,
                                        height: 6,
                                        strokeThickness: 2,
                                        fill: "#0095B230",
                                        stroke: "#0095B2"
                                    })
                                });

                                // Declare a DataSeries

                                lineSeries.dataSeries = new __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](_this2.wasmContext, {
                                    xValues: d,
                                    yValues: yValues
                                });

                                lineSeries.strokeThickness = 3;
                                lineSeries.rolloverModifierProps.tooltipLabelX = _this2.labelX ? _this2.labelX : "X";
                                lineSeries.rolloverModifierProps.tooltipLabelY = _this2.labelY ? _this2.labelY : "Y";
                                _this2.sciChartSurface.renderableSeries.add(lineSeries);

                                _this2.sciChartSurface.zoomExtents();

                            case 18:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        applyStyles: function applyStyles() {
            this.sciChartSurface.applyTheme({
                annotationsGripsBackroundBrush: "white",
                annotationsGripsBorderBrush: "white",
                axis3DBandsFill: "#1F3D6833",
                axisBandsFill: "#1F3D6833",
                axisPlaneBackgroundFill: "Transparent",
                columnFillBrush: "white",
                columnLineColor: "white",
                cursorLineBrush: "#6495ED99",
                defaultColorMapBrush: [{ offset: 0, color: "DarkBlue" }, { offset: 0.5, color: "CornflowerBlue" }, { offset: 1, color: "#FF22AA" }],
                downBandSeriesFillColor: "#52CC5490",
                downBandSeriesLineColor: "#E26565FF",
                downBodyBrush: "white",
                downWickColor: "white",
                gridBackgroundBrush: "white",
                gridBorderBrush: "white",
                labelBackgroundBrush: "#6495EDAA",
                labelBorderBrush: "#6495ED",
                labelForegroundBrush: "#EEEEEE",
                legendBackgroundBrush: "#1D2C35",
                lineSeriesColor: "#0095B2",
                majorGridLineBrush: "#1F3D68",
                minorGridLineBrush: "#102A47",
                mountainAreaBrush: "white",
                mountainLineColor: "white",
                overviewFillBrush: "white",
                planeBorderColor: "white",
                rolloverLineBrush: "#FD9F2533",
                rubberBandFillBrush: "#99999933",
                rubberBandStrokeBrush: "#99999977",
                sciChartBackground: "#0D213A",
                scrollbarBackgroundBrush: "white",
                scrollbarBorderBrush: "white",
                scrollbarGripsBackgroundBrush: "white",
                scrollbarViewportBackgroundBrush: "white",
                scrollbarViewportBorderBrush: "white",
                shadowEffectColor: "white",
                textAnnotationBackground: "#6495EDAA",
                textAnnotationForeground: "#EEEEEE",
                tickTextBrush: "#6495ED",
                upBandSeriesFillColor: "white",
                upBandSeriesLineColor: "white",
                upBodyBrush: "#6495EDA0",
                upWickColor: "#6495ED"
            });
        }
    },
    mounted: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            this.initSciChart();

                        case 1:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function mounted() {
            return _ref2.apply(this, arguments);
        }

        return mounted;
    }(),
    beforeDestroy: function () {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            if (this.sciChartSurface || this.wasmContext) {
                                this.sciChartSurface = null;
                                this.wasmContext = null;
                            }
                            this.sciChartSurface = null;
                            this.wasmContext = null;

                        case 3:
                        case "end":
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function beforeDestroy() {
            return _ref3.apply(this, arguments);
        }

        return beforeDestroy;
    }()
});

/***/ }),

/***/ 1600:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scichart_Charting_Visuals_SciChartSurface__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scichart_Charting_Visuals_SciChartSurface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_scichart_Charting_Visuals_SciChartSurface__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_Axis_NumericAxis__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_Axis_NumericAxis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_Axis_NumericAxis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scichart_types_AxisAlignment__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scichart_types_AxisAlignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_scichart_types_AxisAlignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Model_XyDataSeries__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Model_XyDataSeries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Model_XyDataSeries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_ChartModifiers_ZoomPanModifier__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_ChartModifiers_ZoomPanModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_scichart_Charting_ChartModifiers_ZoomPanModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_MouseWheelZoomModifier__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_MouseWheelZoomModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_MouseWheelZoomModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_ZoomExtentsModifier__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_ZoomExtentsModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_ZoomExtentsModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_chartTheme__ = __webpack_require__(1563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scichart_Core_NumberRange__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scichart_Core_NumberRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_scichart_Core_NumberRange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_scichart_Charting_ChartModifiers_RolloverModifier__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_scichart_Charting_ChartModifiers_RolloverModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_scichart_Charting_ChartModifiers_RolloverModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_scichart_Charting_ChartModifiers_CursorModifier__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_scichart_Charting_ChartModifiers_CursorModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_scichart_Charting_ChartModifiers_CursorModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_scichart_types_XyDirection__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_scichart_types_XyDirection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_scichart_types_XyDirection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_scichart_Charting_Drawing_WebGlRenderContext2D__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_scichart_Charting_Drawing_WebGlRenderContext2D___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_scichart_Charting_Drawing_WebGlRenderContext2D__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__syncfusion_ej2_vue_grids__ = __webpack_require__(953);


//
//
//
//
//
//
//
//
//
//
//
//
//
//





















/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_11__utils_chartTheme__["a" /* chartThemeMixin */]],
    props: ['data', 'labelX', 'labelY', 'zoom', 'pan', 'showValues', 'mouseZoom', 'sid', 'initialZoomOut'],
    provide: {
        grid: [__WEBPACK_IMPORTED_MODULE_19__syncfusion_ej2_vue_grids__["l" /* Sort */], __WEBPACK_IMPORTED_MODULE_19__syncfusion_ej2_vue_grids__["i" /* Page */], __WEBPACK_IMPORTED_MODULE_19__syncfusion_ej2_vue_grids__["g" /* Filter */], __WEBPACK_IMPORTED_MODULE_19__syncfusion_ej2_vue_grids__["m" /* Toolbar */], __WEBPACK_IMPORTED_MODULE_19__syncfusion_ej2_vue_grids__["k" /* Search */], __WEBPACK_IMPORTED_MODULE_19__syncfusion_ej2_vue_grids__["b" /* CommandColumn */]]
    },
    data: function data() {
        return {
            sciChartSurface: null,
            wasmContext: null,
            selection: [],
            wrapSettings: { wrapMode: 'Content' },
            selectionOptions: { type: 'Multiple' },
            filterOptions: {
                type: 'Menu'
            },
            customAttributes: { class: 'customcss' }
        };
    },

    methods: {
        selectionChanged: function selectionChanged() {
            this.selection = this.$refs['grid-' + this.sid].getSelectedRecords();

            if (this.data.length == 0) this.selection = [];

            if (this.sciChartSurface != null) this.redrawScichart();
        },
        redrawScichart: function redrawScichart() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var dataSeries, lineSeries;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.sciChartSurface.renderableSeries.items = [];

                                if (_this.selection.length == 0) {
                                    dataSeries = new __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](_this.wasmContext, {
                                        xValues: {},
                                        yValues: {}
                                    });
                                    lineSeries = new __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__["FastLineRenderableSeries"](_this.wasmContext, {
                                        dataSeries: dataSeries
                                    });


                                    _this.sciChartSurface.renderableSeries.add(lineSeries);
                                }

                                _this.selection.forEach(function (e, index) {

                                    var d = [];
                                    e.yValues.forEach(function (dt, i) {
                                        d.push(new Date(__WEBPACK_IMPORTED_MODULE_18_moment___default()(dt, "DD.MM.YYYY HH.mm.ss")).getTime());
                                    });

                                    var v = [];
                                    e.xValues.forEach(function (dt) {
                                        v.push(dt);
                                    });

                                    var dataSeries = new __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](_this.wasmContext, {
                                        xValues: d,
                                        yValues: v
                                    });

                                    dataSeries.dataSeriesName = e.title;

                                    var lineSeries = new __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__["FastLineRenderableSeries"](_this.wasmContext, {
                                        dataSeries: dataSeries,
                                        stroke: e.strokeColor,
                                        pointMarker: new __WEBPACK_IMPORTED_MODULE_15_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker__["EllipsePointMarker"](_this.wasmContext, {
                                            width: 3,
                                            height: 3,
                                            strokeThickness: 1,
                                            fill: e.strokeColor + "30",
                                            stroke: e.strokeColor
                                        })
                                    });

                                    lineSeries.stroke = e.strokeColor;
                                    lineSeries.rolloverModifierProps.tooltipTitle = e.title;
                                    lineSeries.rolloverModifierProps.tooltipTextColor = '#fff';
                                    lineSeries.rolloverModifierProps.tooltipColor = e.strokeColor;
                                    lineSeries.rolloverModifierProps.tooltipLabelX = _this.labelX ? _this.labelX : "X";
                                    // lineSeries.rolloverModifierProps.tooltipLabelY = this.labelY ? this.labelY : "Y";
                                    _this.sciChartSurface.renderableSeries.add(lineSeries);
                                });

                                if (_this.selection.length != 0) {
                                    _this.sciChartSurface.zoomExtents();
                                }

                            case 4:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        initSciChart: function initSciChart() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var _ref, sciChartSurface, wasmContext, xAxis, yAxis, rolloverModifier;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_2_scichart_Charting_Visuals_SciChartSurface__["SciChartSurface"].create("scichart-root-" + _this2.sid);

                            case 2:
                                _ref = _context2.sent;
                                sciChartSurface = _ref.sciChartSurface;
                                wasmContext = _ref.wasmContext;


                                _this2.sciChartSurface = sciChartSurface;
                                _this2.wasmContext = wasmContext;

                                _context2.next = 9;
                                return sciChartSurface.applyTheme(_this2.chartTheme());

                            case 9:
                                xAxis = new __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_Axis_NumericAxis__["NumericAxis"](_this2.wasmContext, { axisAlignment: __WEBPACK_IMPORTED_MODULE_4_scichart_types_AxisAlignment__["EAxisAlignment"].Top });
                                yAxis = new __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_Axis_NumericAxis__["NumericAxis"](_this2.wasmContext, { axisAlignment: __WEBPACK_IMPORTED_MODULE_4_scichart_types_AxisAlignment__["EAxisAlignment"].Left });


                                if (_this2.initialZoomOut == true) {
                                    yAxis.growBy = new __WEBPACK_IMPORTED_MODULE_12_scichart_Core_NumberRange__["NumberRange"](0.1, 0.1);
                                    xAxis.growBy = new __WEBPACK_IMPORTED_MODULE_12_scichart_Core_NumberRange__["NumberRange"](0.1, 0.1);
                                }

                                _this2.sciChartSurface.xAxes.add(xAxis);
                                _this2.sciChartSurface.yAxes.add(yAxis);

                                xAxis.labelProvider.formatLabel = function (unixTimestamp) {
                                    return __WEBPACK_IMPORTED_MODULE_18_moment___default()(unixTimestamp).format("DD.MM, HH:mm:ss");
                                };

                                _this2.data.forEach(function (e, index) {

                                    var d = [];
                                    e.yValues.forEach(function (dt, i) {
                                        d.push(new Date(__WEBPACK_IMPORTED_MODULE_18_moment___default()(dt, "DD.MM.YYYY HH.mm.ss")).getTime());
                                    });

                                    var v = [];
                                    e.xValues.forEach(function (dt) {
                                        v.push(dt);
                                    });

                                    var dataSeries = new __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](_this2.wasmContext, {
                                        xValues: d,
                                        yValues: v
                                    });

                                    dataSeries.dataSeriesName = e.title;

                                    var lineSeries = new __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__["FastLineRenderableSeries"](_this2.wasmContext, {
                                        dataSeries: dataSeries,
                                        drawNaNAs: __WEBPACK_IMPORTED_MODULE_17_scichart_Charting_Drawing_WebGlRenderContext2D__["ELineDrawMode"].DiscontinuousLine,
                                        stroke: e.strokeColor,
                                        strokeThickness: 3,
                                        pointMarker: new __WEBPACK_IMPORTED_MODULE_15_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker__["EllipsePointMarker"](_this2.wasmContext, {
                                            width: 4,
                                            height: 4,
                                            strokeThickness: 1,
                                            fill: e.strokeColor + "30",
                                            stroke: e.strokeColor
                                        })
                                    });

                                    lineSeries.stroke = e.strokeColor;
                                    lineSeries.rolloverModifierProps.tooltipTitle = e.title;
                                    lineSeries.rolloverModifierProps.tooltipTextColor = '#fff';
                                    lineSeries.rolloverModifierProps.tooltipColor = e.strokeColor;
                                    lineSeries.rolloverModifierProps.tooltipLabelX = _this2.labelX ? _this2.labelX : "X";
                                    // lineSeries.rolloverModifierProps.tooltipLabelY = this.labelY ? this.labelY : "Y";
                                    _this2.sciChartSurface.renderableSeries.add(lineSeries);
                                });

                                if (_this2.zoomBySelection == true) _this2.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier__["RubberBandXyZoomModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_16_scichart_types_XyDirection__["EXyDirection"].XDirection }));
                                if (_this2.pan != false) _this2.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_ChartModifiers_ZoomPanModifier__["ZoomPanModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_16_scichart_types_XyDirection__["EXyDirection"].XDirection }));
                                if (_this2.zoom != false) _this2.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_ZoomExtentsModifier__["ZoomExtentsModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_16_scichart_types_XyDirection__["EXyDirection"].XDirection }));
                                if (_this2.mouseZoom != false) _this2.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_MouseWheelZoomModifier__["MouseWheelZoomModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_16_scichart_types_XyDirection__["EXyDirection"].XDirection }));
                                rolloverModifier = new __WEBPACK_IMPORTED_MODULE_13_scichart_Charting_ChartModifiers_RolloverModifier__["RolloverModifier"]();

                                rolloverModifier.showRolloverLine = false;
                                _this2.sciChartSurface.chartModifiers.add(rolloverModifier);

                                _this2.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_14_scichart_Charting_ChartModifiers_CursorModifier__["CursorModifier"]({
                                    crosshairStroke: "#0095B2",
                                    crosshairStrokeThickness: 1,
                                    tooltipContainerBackground: "#000",
                                    tooltipTextStroke: "#0095B2",
                                    showTooltip: false,
                                    axisLabelFill: "#0095B2",
                                    axisLabelStroke: "#fff"
                                }));

                                _this2.sciChartSurface.zoomExtents();

                            case 25:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        applyStyles: function applyStyles() {
            this.sciChartSurface.applyTheme({
                annotationsGripsBackroundBrush: "white",
                annotationsGripsBorderBrush: "white",
                axis3DBandsFill: "#1F3D6833",
                axisBandsFill: "#1F3D6833",
                axisPlaneBackgroundFill: "Transparent",
                columnFillBrush: "white",
                columnLineColor: "white",
                cursorLineBrush: "#6495ED99",
                defaultColorMapBrush: [{ offset: 0, color: "DarkBlue" }, { offset: 0.5, color: "CornflowerBlue" }, { offset: 1, color: "#FF22AA" }],
                downBandSeriesFillColor: "#6495ED99", // "#52CC5490",
                downBandSeriesLineColor: "#E26565FF",
                downBodyBrush: "white",
                downWickColor: "white",
                gridBackgroundBrush: "white",
                gridBorderBrush: "white",
                labelBackgroundBrush: "#6495EDAA",
                labelBorderBrush: "#6495ED",
                labelForegroundBrush: "#EEEEEE",
                legendBackgroundBrush: "#1D2C35",
                lineSeriesColor: "#0095B2",
                majorGridLineBrush: "#1F3D68",
                minorGridLineBrush: "#102A47",
                mountainAreaBrush: "white",
                mountainLineColor: "white",
                overviewFillBrush: "white",
                planeBorderColor: "white",
                rolloverLineBrush: "#FD9F2533",
                rubberBandFillBrush: "#99999933",
                rubberBandStrokeBrush: "#99999977",
                sciChartBackground: "#0D213A",
                scrollbarBackgroundBrush: "white",
                scrollbarBorderBrush: "white",
                scrollbarGripsBackgroundBrush: "white",
                scrollbarViewportBackgroundBrush: "white",
                scrollbarViewportBorderBrush: "white",
                shadowEffectColor: "white",
                textAnnotationBackground: "#6495EDAA",
                textAnnotationForeground: "#EEEEEE",
                tickTextBrush: "#6495ED",
                upBandSeriesFillColor: "white",
                upBandSeriesLineColor: "white",
                upBodyBrush: "#6495EDA0",
                upWickColor: "#6495ED"
            });
        },

        dataBound: function dataBound() {
            this.$refs['grid-' + this.sid].autoFitColumns();
            var rowIndexes = [];
            this.data.forEach(function (e, i) {
                rowIndexes.push(i);
            });
            this.$refs['grid-' + this.sid].selectRows(rowIndexes);
        },
        rowDataBound: function rowDataBound(args) {
            args.row.classList.add('whiteText');
            args.row.style.backgroundColor = args.data['strokeColor'];
        }
    },
    mounted: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            this.initSciChart();

                        case 1:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function mounted() {
            return _ref2.apply(this, arguments);
        }

        return mounted;
    }(),
    beforeDestroy: function () {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            if (this.sciChartSurface || this.wasmContext) {
                                this.sciChartSurface = null;
                                this.wasmContext = null;
                            }
                            this.sciChartSurface = null;
                            this.wasmContext = null;

                        case 3:
                        case "end":
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function beforeDestroy() {
            return _ref3.apply(this, arguments);
        }

        return beforeDestroy;
    }(),
    updated: function () {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            if (this.data.length == 0) {
                                this.selectionChanged();
                            }

                        case 1:
                        case "end":
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        }));

        function updated() {
            return _ref4.apply(this, arguments);
        }

        return updated;
    }()
});

/***/ }),

/***/ 1601:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_SciChartSurface__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_SciChartSurface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_SciChartSurface__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_Axis_NumericAxis__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_Axis_NumericAxis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_Axis_NumericAxis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_scichart_types_AxisAlignment__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_scichart_types_AxisAlignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_scichart_types_AxisAlignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Model_XyDataSeries__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Model_XyDataSeries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Model_XyDataSeries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_ZoomPanModifier__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_ZoomPanModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_ZoomPanModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_MouseWheelZoomModifier__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_MouseWheelZoomModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_MouseWheelZoomModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_scichart_Charting_ChartModifiers_ZoomExtentsModifier__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_scichart_Charting_ChartModifiers_ZoomExtentsModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_scichart_Charting_ChartModifiers_ZoomExtentsModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_chartTheme__ = __webpack_require__(1563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_scichart_Core_NumberRange__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_scichart_Core_NumberRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_scichart_Core_NumberRange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_scichart_Charting_ChartModifiers_CursorModifier__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_scichart_Charting_ChartModifiers_CursorModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_scichart_Charting_ChartModifiers_CursorModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_scichart_types_XyDirection__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_scichart_types_XyDirection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_scichart_types_XyDirection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_scichart_Charting_Drawing_WebGlRenderContext2D__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_scichart_Charting_Drawing_WebGlRenderContext2D___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_scichart_Charting_Drawing_WebGlRenderContext2D__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_scichart_Charting_Visuals_Annotations_VerticalLineAnnotation__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_scichart_Charting_Visuals_Annotations_VerticalLineAnnotation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_scichart_Charting_Visuals_Annotations_VerticalLineAnnotation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_scichart_types_LabelPlacement__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_scichart_types_LabelPlacement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_scichart_types_LabelPlacement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_scichart_Charting_Visuals_Axis_LabelProvider_LabelProvider__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_scichart_Charting_Visuals_Axis_LabelProvider_LabelProvider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_scichart_Charting_Visuals_Axis_LabelProvider_LabelProvider__);



//
//
//
//
//
//
//
//





















/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_12__utils_chartTheme__["a" /* chartThemeMixin */]],
    props: ['dataset', 'devices', 'day', 'name', 'activeSet', 'labelX', 'labelY', 'zoom', 'pan', 'showValues', 'mouseZoom', 'sid', 'initialZoomOut'],
    data: function data() {
        var dateDay = new Date();
        dateDay.setDate(dateDay.getDate() - this.day);
        dateDay = new Date(dateDay.getFullYear(), dateDay.getMonth(), dateDay.getDate(), 0, 0, 0);

        return {
            sciChartSurface: null,
            wasmContext: null,
            init: false,
            data: [],
            dateFrom: dateDay,
            dateTo: new Date(dateDay.getFullYear(), dateDay.getMonth(), dateDay.getDate(), 23, 59, 59)
        };
    },

    watch: {
        dataset: function dataset(newVal, oldVal) {
            if (newVal != 0) {
                this.changeDataSet(newVal, false);
            }
        }
    },
    methods: {
        initSciChart: function initSciChart() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _ref, sciChartSurface, wasmContext, xAxis, yAxis, lastRange;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_SciChartSurface__["SciChartSurface"].create("scichart-root-" + _this.sid);

                            case 2:
                                _ref = _context.sent;
                                sciChartSurface = _ref.sciChartSurface;
                                wasmContext = _ref.wasmContext;


                                _this.sciChartSurface = sciChartSurface;
                                _this.wasmContext = wasmContext;

                                sciChartSurface.applyTheme(_this.chartTheme());

                                xAxis = new __WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_Axis_NumericAxis__["NumericAxis"](_this.wasmContext, {
                                    axisAlignment: __WEBPACK_IMPORTED_MODULE_5_scichart_types_AxisAlignment__["EAxisAlignment"].Top,
                                    drawMajorBands: true,
                                    majorGridLineStyle: {
                                        color: "#9D9D9D"
                                    }
                                });
                                yAxis = new __WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_Axis_NumericAxis__["NumericAxis"](_this.wasmContext, { axisAlignment: __WEBPACK_IMPORTED_MODULE_5_scichart_types_AxisAlignment__["EAxisAlignment"].Left });

                                yAxis.labelProvider.formatLabel = function (dataValue) {
                                    return parseInt(dataValue);
                                };
                                yAxis.maxAutoTicks = 2;
                                yAxis.minorsPerMajor = 2;
                                yAxis.visibleRange = new __WEBPACK_IMPORTED_MODULE_13_scichart_Core_NumberRange__["NumberRange"](1, 2);

                                if (_this.initialZoomOut == true) {
                                    yAxis.growBy = new __WEBPACK_IMPORTED_MODULE_13_scichart_Core_NumberRange__["NumberRange"](0.02, 0.02);
                                    xAxis.growBy = new __WEBPACK_IMPORTED_MODULE_13_scichart_Core_NumberRange__["NumberRange"](0.02, 0.02);
                                }

                                _this.sciChartSurface.xAxes.add(xAxis);
                                _this.sciChartSurface.yAxes.add(yAxis);

                                xAxis.labelProvider.formatLabel = function (dt) {
                                    return __WEBPACK_IMPORTED_MODULE_19_moment___default()(dt).format("DD.MM, HH:mm:ss");
                                };

                                yAxis.labelProvider.formatLabel = function (val) {
                                    return _this.name;
                                };

                                sciChartSurface.annotations.add(new __WEBPACK_IMPORTED_MODULE_17_scichart_Charting_Visuals_Annotations_VerticalLineAnnotation__["VerticalLineAnnotation"]({
                                    labelPlacement: __WEBPACK_IMPORTED_MODULE_18_scichart_types_LabelPlacement__["ELabelPlacement"].Axis,
                                    showLabel: true,
                                    stroke: "Red",
                                    strokeThickness: 2,
                                    x1: Date.now(),
                                    axisLabelFill: "Red",
                                    labelValue: _this.$t("Now")
                                }));

                                _context.next = 22;
                                return _this.populateSciChart(true);

                            case 22:

                                xAxis.autoTicks = false, xAxis.majorDelta = 3600000;
                                xAxis.minorDelta = 720000;
                                lastRange = 3;


                                xAxis.visibleRangeChanged.subscribe(function (args) {
                                    var rangeDiff = args.visibleRange.max - args.visibleRange.min;

                                    if (rangeDiff / 3600000 <= 1 && lastRange != 0) {
                                        xAxis.majorDelta = 60000;
                                        xAxis.minorDelta = 12000;
                                        lastRange = 0;
                                    } else if (rangeDiff / 3600000 <= 2 && rangeDiff / 3600000 >= 1 && lastRange != 1) {
                                        xAxis.majorDelta = 600000;
                                        xAxis.minorDelta = 120000;
                                        lastRange = 1;
                                    } else if (rangeDiff / 3600000 > 2 && rangeDiff / 3600000 <= 6 && lastRange != 2) {
                                        xAxis.majorDelta = 1800000;
                                        xAxis.minorDelta = 360000;
                                        lastRange = 2;
                                    } else if (rangeDiff / 3600000 > 6 && lastRange != 3) {
                                        xAxis.majorDelta = 3600000;
                                        xAxis.minorDelta = 720000;
                                        lastRange = 3;
                                    }
                                });

                            case 26:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        reloadSciChart: function reloadSciChart() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(_this2.sciChartSurface != null)) {
                                    _context2.next = 4;
                                    break;
                                }

                                if (_this2.sciChartSurface.renderableSeries != null) {
                                    _this2.sciChartSurface.renderableSeries.items = [];
                                }

                                _context2.next = 4;
                                return _this2.populateSciChart(false);

                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        populateSciChart: function populateSciChart(init) {
            var _this3 = this;

            this.data.forEach(function (e, i) {
                var d = [];
                var d2 = [];
                var v = [];
                var v2 = [];
                var value = e.xValues.filter(function (x) {
                    return !isNaN(x);
                })[0];

                if (value == undefined) {
                    value = parseInt(e.title);
                }

                //DF-1
                var c1 = new Date(_this3.dateFrom);
                c1.setSeconds(c1.getSeconds() - 1);
                d2.push(c1);
                if (e.xValues.length != 2) {
                    d2.push(_this3.dateFrom);
                }
                //DTs
                e.yValues.forEach(function (dt, j) {
                    d.push(new Date(__WEBPACK_IMPORTED_MODULE_19_moment___default()(dt, "DD.MM.YYYY HH.mm.ss")));
                    d2.push(new Date(__WEBPACK_IMPORTED_MODULE_19_moment___default()(dt, "DD.MM.YYYY HH.mm.ss")));
                });
                //DT+1
                if (e.xValues.length != 2) {
                    d2.push(_this3.dateTo);
                }
                var e1 = new Date(_this3.dateTo);
                e1.setSeconds(e1.getSeconds() + 1);
                d2.push(e1);

                v2.push(NaN);
                v2.push(value);
                if (e.xValues.length != 2) {
                    e.xValues.forEach(function (val, j) {
                        v.push(val);
                        v2.push(!isNaN(val) ? NaN : value);
                    });
                }
                v2.push(value);
                v2.push(NaN);

                if (v.some(function (x) {
                    return !isNaN(x);
                })) {
                    var dataSeries = new __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](_this3.wasmContext, {
                        // SciChart przyjmuje na osi X tylko liczby - daty jako znaczniki czasu w ms.
                        xValues: d.map(function (x) {
                            return new Date(x).getTime();
                        }),
                        yValues: v
                    });

                    dataSeries.dataSeriesName = e.title;

                    var lineSeries = new __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__["FastLineRenderableSeries"](_this3.wasmContext, {
                        dataSeries: dataSeries,
                        drawNaNAs: __WEBPACK_IMPORTED_MODULE_16_scichart_Charting_Drawing_WebGlRenderContext2D__["ELineDrawMode"].DiscontinuousLine,
                        stroke: '#E06C65',
                        strokeThickness: 15
                    });

                    lineSeries.strokeColor = '#E06C65';
                    lineSeries.rolloverModifierProps.tooltipTitle = e.title;
                    lineSeries.rolloverModifierProps.tooltipTextColor = '#fff';
                    lineSeries.rolloverModifierProps.tooltipColor = e.strokeColor;
                    lineSeries.rolloverModifierProps.tooltipLabelX = _this3.labelX ? _this3.labelX : "X";
                    _this3.sciChartSurface.renderableSeries.add(lineSeries);
                }

                d2 = d2.sort(function (a, b) {
                    return new Date(a) - new Date(b);
                });

                var greenDataSeries = new __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](_this3.wasmContext, {
                    xValues: d2.map(function (x) {
                        return new Date(x).getTime();
                    }),
                    yValues: v2
                });

                greenDataSeries.dataSeriesName = e.title;

                var lineSeries2 = new __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__["FastLineRenderableSeries"](_this3.wasmContext, {
                    drawNaNAs: __WEBPACK_IMPORTED_MODULE_16_scichart_Charting_Drawing_WebGlRenderContext2D__["ELineDrawMode"].DiscontinuousLine,
                    stroke: '#84CA85',
                    strokeThickness: 10
                });

                lineSeries2.dataSeries = greenDataSeries;

                _this3.sciChartSurface.renderableSeries.add(lineSeries2);
            });

            if (init) {
                if (this.zoomBySelection == true) this.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier__["RubberBandXyZoomModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_15_scichart_types_XyDirection__["EXyDirection"].XDirection }));
                if (this.pan != false) this.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_ZoomPanModifier__["ZoomPanModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_15_scichart_types_XyDirection__["EXyDirection"].XDirection }));
                if (this.zoom != false) this.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_11_scichart_Charting_ChartModifiers_ZoomExtentsModifier__["ZoomExtentsModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_15_scichart_types_XyDirection__["EXyDirection"].XDirection }));
                if (this.mouseZoom != false) this.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_MouseWheelZoomModifier__["MouseWheelZoomModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_15_scichart_types_XyDirection__["EXyDirection"].XDirection }));

                this.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_14_scichart_Charting_ChartModifiers_CursorModifier__["CursorModifier"]({
                    crosshairStroke: "#0095B2",
                    crosshairStrokeThickness: 1,
                    tooltipContainerBackground: "#000",
                    tooltipTextStroke: "#0095B2",
                    showTooltip: false,
                    axisLabelFill: "#0095B2",
                    axisLabelStroke: "#fff"
                }));
            }

            this.sciChartSurface.zoomExtents();
        },
        changeDataSet: function changeDataSet(index, init) {
            var _this4 = this;

            var set = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.dataset));

            //sort dataset
            set.sort(function (a, b) {
                return new Date(a.createDate) - new Date(b.createDate);
            });

            var dev = { xValues: [], yValues: [], title: -1 };

            set.forEach(function (e, i) {
                var c1 = new Date(e.createDate);
                c1.setSeconds(c1.getSeconds() - 1);
                dev.yValues.push(c1);
                dev.xValues.push(NaN);

                dev.yValues.push(new Date(e.createDate));

                if (new Date(e.endDate) > _this4.dateTo) {
                    dev.yValues.push(new Date(_this4.dateTo));
                    var e1 = new Date(_this4.dateTo);
                    e1.setSeconds(e1.getSeconds() + 1);
                    dev.yValues.push(e1);
                } else {
                    dev.yValues.push(new Date(e.endDate));
                    var e1 = new Date(e.endDate);
                    e1.setSeconds(e1.getSeconds() + 1);
                    dev.yValues.push(e1);
                }

                dev.xValues.push(1);
                dev.xValues.push(1);

                dev.xValues.push(NaN);
            });

            dev.title = 1;

            this.data = [];
            this.data.push(dev);
            if (init == false) {
                this.reloadSciChart();
            }
        }
    },
    mounted: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            if (!(this.dataset.length == 0)) {
                                _context3.next = 5;
                                break;
                            }

                            _context3.next = 3;
                            return this.initSciChart();

                        case 3:
                            this.init = true;
                            return _context3.abrupt("return");

                        case 5:
                            this.changeDataSet(this.activeSet, true);
                            _context3.next = 8;
                            return this.initSciChart();

                        case 8:
                            this.init = true;

                        case 9:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function mounted() {
            return _ref2.apply(this, arguments);
        }

        return mounted;
    }(),
    beforeDestroy: function () {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            if (this.sciChartSurface || this.wasmContext) {
                                this.sciChartSurface = null;
                                this.wasmContext = null;
                            }
                            this.sciChartSurface = null;
                            this.wasmContext = null;

                        case 3:
                        case "end":
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function beforeDestroy() {
            return _ref3.apply(this, arguments);
        }

        return beforeDestroy;
    }()
});

/***/ }),

/***/ 1602:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(1578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// Kolejność kolorów jest stała i przypisana do typu alarmu (po jego id), a nie do
// pozycji w legendzie — wyłączenie typu filtrem nie przemalowuje pozostałych.
// Paleta sprawdzona walidatorem kontrastu i daltonizmu dla obu motywów (tło #ffffff / #172124).
var SERIES_COUNT = 8;

var MINUTE = 60 * 1000;
var HOUR = 60 * MINUTE;
var DAY = 24 * HOUR;
var TICK_STEPS = [MINUTE, 2 * MINUTE, 5 * MINUTE, 10 * MINUTE, 15 * MINUTE, 30 * MINUTE, HOUR, 2 * HOUR, 3 * HOUR, 6 * HOUR];
var MIN_RANGE = 5 * MINUTE;
var MIN_BAR_WIDTH = 3;

var LOCALES = { Polish: 'pl', English: 'en', Norwegian: 'nb' };

var pad = function pad(n) {
    return String(n).padStart(2, '0');
};

// Oś X to zawsze godzina doby (0–24 h). Tryby wierszy:
//  - 'device': jeden dzień (prop day), wiersz na urządzenie / „System” / „Zwierzęta”;
//  - 'day':    zakres dni (rangeFrom–rangeTo), wiersz na dzień. Alarm przechodzący przez
//              północ jest dzielony na odcinki w kolejnych wierszach (◀ ▶ na granicy).
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'AlarmDayTimeline',
    props: {
        // createDate/endDate jako Date albo tekst; endDate null = bez końca.
        alarms: { type: Array, required: true },
        rowsBy: { type: String, default: 'device' },
        // Tryb 'device': ile dni temu (0 = dzisiaj).
        day: { type: Number, default: 0 },
        // Tryb 'day': zakres dni (włącznie).
        rangeFrom: { default: null },
        rangeTo: { default: null },
        selectedId: { default: null },
        maxBodyHeight: { type: String, default: '40vh' }
    },
    data: function data() {
        return {
            width: 800,
            labelWidth: 150,
            axisHeight: 26,
            barHeight: 12,
            laneGap: 4,
            rowPadding: 6,
            viewFrom: null,
            viewTo: null,
            hiddenTypes: {},
            onlyActive: false,
            now: Date.now(),
            tooltip: null,
            cursor: null,
            drag: null
        };
    },

    computed: {
        locale: function locale() {
            return LOCALES[this.$store.getters.language] || 'en';
        },

        // Północ każdego pokazywanego dnia.
        dayStarts: function dayStarts() {
            if (this.rowsBy === 'day') {
                var first = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.rangeFrom || Date.now()).startOf('day');
                var last = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.rangeTo || Date.now()).startOf('day');
                var days = [];
                for (var d = first.clone(); !d.isAfter(last); d.add(1, 'days')) {
                    days.push(d.valueOf());
                }return days;
            }
            return [__WEBPACK_IMPORTED_MODULE_2_moment___default()().startOf('day').subtract(this.day, 'days').valueOf()];
        },
        from: function from() {
            return this.viewFrom != null ? this.viewFrom : 0;
        },
        to: function to() {
            return this.viewTo != null ? this.viewTo : DAY;
        },
        isZoomed: function isZoomed() {
            return this.from > 0 || this.to < DAY;
        },
        plotWidth: function plotWidth() {
            return Math.max(100, this.width - this.labelWidth - 16);
        },
        rangeLabel: function rangeLabel() {
            var first = this.dayStarts[0];
            var last = this.dayStarts[this.dayStarts.length - 1];
            var dates = first === last ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(first).format('DD.MM.YYYY') : __WEBPACK_IMPORTED_MODULE_2_moment___default()(first).format('DD.MM') + ' \u2013 ' + __WEBPACK_IMPORTED_MODULE_2_moment___default()(last).format('DD.MM.YYYY');
            if (!this.isZoomed) return dates;
            return dates + '  ' + this.formatOffset(this.from) + ' \u2013 ' + this.formatOffset(this.to);
        },
        intervals: function intervals() {
            var _this = this;

            return this.alarms.map(function (a, index) {
                var start = new Date(a.createDate).getTime();
                // Brak końca (null) bez IsActive to zdarzenie bez czasu trwania.
                var rawEnd = a.endDate != null ? new Date(a.endDate) : null;
                var hasEnd = rawEnd != null && !isNaN(rawEnd.getTime()) && rawEnd.getTime() >= start;
                var end = a.isActive ? Math.max(start, _this.now) : hasEnd ? rawEnd.getTime() : start;
                var typeKey = a.alarmTypeId != null ? String(a.alarmTypeId) : String(a.alarmType);
                var isAnimal = a.deviceId == null && typeof a.type === 'string' && a.type.indexOf('Animal') === 0;

                return {
                    id: a.id != null ? a.id : 'i' + index,
                    start: start,
                    end: end,
                    isActive: !!a.isActive,
                    typeKey: typeKey,
                    typeName: a.alarmType,
                    // Opcjonalny opis konkretnego alarmu (modale jednego urządzenia).
                    description: a.description || null,
                    deviceKey: a.deviceId != null ? 'd:' + a.deviceId : isAnimal ? 'animals' : 'system',
                    deviceLabel: a.deviceId != null ? ((a.type || '') + ' ' + a.number).trim() : _this.$t(isAnimal ? 'Animals' : 'System'),
                    deviceOrder: a.deviceId != null ? [2, String(a.type || ''), a.number] : [isAnimal ? 1 : 0, '', 0],
                    animal: isAnimal ? a.type.replace('Animal:', '').trim() : null,
                    withDate: _this.rowsBy === 'day' || !__WEBPACK_IMPORTED_MODULE_2_moment___default()(start).isSame(end, 'day')
                };
            });
        },
        types: function types() {
            var _this2 = this;

            var byKey = {};
            this.intervals.forEach(function (i) {
                if (byKey[i.typeKey] == null) byKey[i.typeKey] = { key: i.typeKey, name: i.typeName, count: 0 };
                byKey[i.typeKey].count++;
            });
            var list = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(byKey).map(function (k) {
                return byKey[k];
            });
            list.sort(function (a, b) {
                return _this2.compareIds(a.key, b.key);
            });
            // Ponad 8 typów: reszta dostaje neutralny szary zamiast wymyślonego koloru.
            list.forEach(function (t, i) {
                t.color = i < SERIES_COUNT ? 'var(--adt-s' + (i + 1) + ')' : 'var(--adt-other)';
            });
            return byKey;
        },
        legendTypes: function legendTypes() {
            var _this3 = this;

            var list = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.types).map(function (k) {
                return _this3.types[k];
            });
            return list.sort(function (a, b) {
                return b.count - a.count || String(a.name).localeCompare(String(b.name));
            });
        },
        visibleIntervals: function visibleIntervals() {
            var _this4 = this;

            return this.intervals.filter(function (i) {
                return !_this4.hiddenTypes[i.typeKey] && (!_this4.onlyActive || i.isActive);
            });
        },

        // Odcinki alarmów w obrębie jednej doby, z wierszem, do którego należą.
        segments: function segments() {
            var _this5 = this;

            var segments = [];
            this.visibleIntervals.forEach(function (i) {
                _this5.dayStarts.forEach(function (ds) {
                    var de = ds + DAY;
                    var inside = i.end > i.start ? i.start < de && i.end > ds : i.start >= ds && i.start < de;
                    if (!inside) return;
                    var isDayRow = _this5.rowsBy === 'day';
                    segments.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, i, {
                        dayStart: ds,
                        segStart: Math.max(i.start, ds) - ds,
                        segEnd: Math.min(i.end, de) - ds,
                        continuesLeft: i.start < ds,
                        continuesRight: i.end > de || i.isActive && i.end <= de,
                        rowKey: isDayRow ? 'day:' + ds : i.deviceKey,
                        rowLabel: isDayRow ? _this5.dayLabel(ds) : i.deviceLabel,
                        rowOrder: isDayRow ? [ds, '', 0] : i.deviceOrder
                    }));
                });
            });
            return segments;
        },
        rows: function rows() {
            var _this6 = this;

            var byKey = {};
            var addRow = function addRow(key, label, order, dayStart) {
                if (byKey[key] == null) byKey[key] = { key: key, label: label, order: order, dayStart: dayStart, items: [] };
                return byKey[key];
            };
            // Dni bez alarmów też są wierszami — pusty dzień to też informacja.
            if (this.rowsBy === 'day') {
                this.dayStarts.forEach(function (ds) {
                    return addRow('day:' + ds, _this6.dayLabel(ds), [ds, '', 0], ds);
                });
            }
            this.segments.forEach(function (s) {
                return addRow(s.rowKey, s.rowLabel, s.rowOrder, s.dayStart).items.push(s);
            });

            var rows = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(byKey).map(function (k) {
                return byKey[k];
            });
            rows.sort(function (a, b) {
                return a.order[0] - b.order[0] || a.order[1].localeCompare(b.order[1]) || a.order[2] - b.order[2];
            });

            // Nakładające się alarmy w jednym wierszu idą na osobne pasy, żeby się nie zasłaniały.
            var y = 0;
            rows.forEach(function (row) {
                var laneEnds = [];
                row.items.sort(function (a, b) {
                    return a.segStart - b.segStart;
                });
                row.lanes = row.items.map(function (item) {
                    var lane = laneEnds.findIndex(function (end) {
                        return end < item.segStart;
                    });
                    if (lane === -1) {
                        lane = laneEnds.length;
                        laneEnds.push(item.segEnd);
                    } else {
                        laneEnds[lane] = item.segEnd;
                    }
                    return lane;
                });
                var laneCount = Math.max(1, laneEnds.length);
                row.y = y;
                row.height = _this6.rowPadding * 2 + laneCount * _this6.barHeight + (laneCount - 1) * _this6.laneGap;
                y += row.height + 2;
            });
            return rows;
        },
        bodyHeight: function bodyHeight() {
            var last = this.rows[this.rows.length - 1];
            return last ? last.y + last.height : 0;
        },
        bars: function bars() {
            var _this7 = this;

            var bars = [];
            this.rows.forEach(function (row) {
                row.items.forEach(function (item, idx) {
                    if (item.segEnd < _this7.from || item.segStart > _this7.to) return;
                    var x1 = _this7.x(Math.max(item.segStart, _this7.from));
                    var x2 = _this7.x(Math.min(item.segEnd, _this7.to));
                    bars.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
                        key: item.id + '|' + row.key,
                        x: x1,
                        w: Math.max(MIN_BAR_WIDTH, x2 - x1),
                        y: row.y + _this7.rowPadding + row.lanes[idx] * (_this7.barHeight + _this7.laneGap),
                        color: _this7.types[item.typeKey].color,
                        continuesLeft: item.continuesLeft || item.segStart < _this7.from,
                        continuesRight: item.continuesRight || item.segEnd > _this7.to
                    }));
                });
            });
            return bars;
        },

        // Wiersze, w których dobie jest „teraz”: linia i wyszarzona przyszłość.
        nowRows: function nowRows() {
            var _this8 = this;

            return this.rows.filter(function (row) {
                return _this8.now - row.dayStart < DAY && _this8.now - row.dayStart >= 0 && _this8.now - row.dayStart < _this8.to;
            }).map(function (row) {
                var offset = _this8.now - row.dayStart;
                return {
                    key: row.key,
                    y: row.y,
                    height: row.height,
                    nowX: offset >= _this8.from ? _this8.x(offset) : null,
                    futureX: _this8.x(Math.max(offset, _this8.from))
                };
            });
        },
        nowLines: function nowLines() {
            return this.nowRows.filter(function (row) {
                return row.nowX != null;
            });
        },
        ticks: function ticks() {
            var range = this.to - this.from;
            var maxTicks = Math.max(2, Math.floor(this.plotWidth / 70));
            var step = TICK_STEPS.find(function (s) {
                return range / s <= maxTicks;
            }) || TICK_STEPS[TICK_STEPS.length - 1];
            var ticks = [];
            for (var t = Math.ceil(this.from / step) * step; t <= this.to; t += step) {
                ticks.push({ t: t, x: this.x(t), label: this.formatOffset(t) });
            }
            return ticks;
        }
    },
    watch: {
        visibleIntervals: {
            immediate: true,
            handler: function handler(list) {
                // Tabela pod osią czasu pokazuje to samo co oś (ten sam filtr typów).
                var ids = {};
                list.forEach(function (i) {
                    ids[i.id] = true;
                });
                this.$emit('visible-change', this.alarms.filter(function (a, index) {
                    return ids[a.id != null ? a.id : 'i' + index];
                }));
            }
        },
        day: function day() {
            this.resetZoom();
        }
    },
    methods: {
        x: function x(offset) {
            return this.labelWidth + (offset - this.from) / (this.to - this.from) * this.plotWidth;
        },
        offsetAt: function offsetAt(px) {
            var clamped = Math.min(Math.max(px, this.labelWidth), this.labelWidth + this.plotWidth);
            return this.from + (clamped - this.labelWidth) / this.plotWidth * (this.to - this.from);
        },
        compareIds: function compareIds(a, b) {
            var na = parseInt(a, 10);
            var nb = parseInt(b, 10);
            if (!isNaN(na) && !isNaN(nb) && na !== nb) return na - nb;
            return a.localeCompare(b);
        },
        dayLabel: function dayLabel(ds) {
            var d = new Date(ds);
            return d.toLocaleDateString(this.locale, { weekday: 'short' }) + ' ' + __WEBPACK_IMPORTED_MODULE_2_moment___default()(ds).format('DD.MM');
        },

        // Godzina doby z przesunięcia od północy; koniec doby to 24:00, nie 00:00.
        formatOffset: function formatOffset(offset, withSeconds) {
            var total = Math.round(offset / 1000);
            var h = Math.floor(total / 3600);
            var m = Math.floor(total % 3600 / 60);
            var s = total % 60;
            return withSeconds ? pad(h) + ':' + pad(m) + ':' + pad(s) : pad(h) + ':' + pad(m);
        },
        formatClock: function formatClock(t, withSeconds) {
            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(t).format(withSeconds ? 'HH:mm:ss' : 'HH:mm');
        },
        formatMoment: function formatMoment(t, withDate) {
            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(t).format(withDate ? 'DD.MM HH:mm:ss' : 'HH:mm:ss');
        },
        formatDuration: function formatDuration(ms) {
            var minutes = Math.floor(ms / MINUTE);
            if (minutes < 1) return this.$t('TimelineLessThanMinute');
            var d = Math.floor(minutes / (24 * 60));
            var h = Math.floor(minutes % (24 * 60) / 60);
            var m = minutes % 60;
            if (d > 0) return d + ' d ' + h + ' h ' + m + ' min';
            return h > 0 ? h + ' h ' + m + ' min' : m + ' min';
        },
        toggleType: function toggleType(key) {
            this.$set(this.hiddenTypes, key, !this.hiddenTypes[key]);
        },
        setView: function setView(from, to) {
            var range = Math.min(DAY, Math.max(MIN_RANGE, to - from));
            var f = Math.max(0, Math.min(from, DAY - range));
            this.viewFrom = f;
            this.viewTo = f + range;
        },
        resetZoom: function resetZoom() {
            this.viewFrom = null;
            this.viewTo = null;
        },
        zoomOut: function zoomOut() {
            var center = (this.from + this.to) / 2;
            var range = (this.to - this.from) * 2;
            this.setView(center - range / 2, center + range / 2);
        },
        pan: function pan(direction) {
            var shift = (this.to - this.from) / 2 * direction;
            this.setView(this.from + shift, this.to + shift);
        },
        localX: function localX(event) {
            var rect = this.$refs.body.getBoundingClientRect();
            return event.clientX - rect.left;
        },
        startDrag: function startDrag(event) {
            if (event.button !== 0) return;
            var px = this.localX(event);
            if (px < this.labelWidth) return;
            this.drag = { x1: px, x2: px };
            window.addEventListener('mousemove', this.onDragMove);
            window.addEventListener('mouseup', this.endDrag);
        },
        onDragMove: function onDragMove(event) {
            if (this.drag == null) return;
            var px = Math.min(Math.max(this.localX(event), this.labelWidth), this.labelWidth + this.plotWidth);
            this.drag = { x1: this.drag.x1, x2: px };
        },
        endDrag: function endDrag() {
            window.removeEventListener('mousemove', this.onDragMove);
            window.removeEventListener('mouseup', this.endDrag);
            var drag = this.drag;
            this.drag = null;
            if (drag == null || Math.abs(drag.x2 - drag.x1) < 6) return;
            // Zaokrąglenie do okrągłych godzin, żeby zakres nie wyglądał na przypadkowy (04:59 – 08:02).
            var rawFrom = this.offsetAt(Math.min(drag.x1, drag.x2));
            var rawTo = this.offsetAt(Math.max(drag.x1, drag.x2));
            var span = rawTo - rawFrom;
            var snap = span > 2 * HOUR ? 15 * MINUTE : span > 30 * MINUTE ? 5 * MINUTE : MINUTE;
            this.setView(Math.round(rawFrom / snap) * snap, Math.round(rawTo / snap) * snap);
        },
        moveCursor: function moveCursor(event) {
            var px = this.localX(event);
            if (px < this.labelWidth || px > this.labelWidth + this.plotWidth) {
                this.cursor = null;
                return;
            }
            this.cursor = { x: px, label: this.formatOffset(this.offsetAt(px), this.to - this.from <= 2 * HOUR) };
        },
        leavePlot: function leavePlot() {
            this.cursor = null;
            this.hideTooltip();
        },
        showTooltip: function showTooltip(event, bar) {
            var rootRect = this.$refs.root.getBoundingClientRect();
            var left = event.clientX - rootRect.left + 14;
            var top = event.clientY - rootRect.top + 14;
            if (left + 260 > rootRect.width) left = event.clientX - rootRect.left - 274;
            this.tooltip = { bar: bar, left: Math.max(0, left), top: top };
        },
        hideTooltip: function hideTooltip() {
            this.tooltip = null;
        },
        measure: function measure() {
            var root = this.$refs.root;
            if (root == null) return;
            // clientWidth liczy też padding, a SVG stoi wewnątrz niego.
            var style = window.getComputedStyle(root);
            this.width = root.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
        }
    },
    mounted: function mounted() {
        var _this9 = this;

        this.measure();
        if (typeof ResizeObserver !== 'undefined') {
            this.resizeObserver = new ResizeObserver(function () {
                return _this9.measure();
            });
            this.resizeObserver.observe(this.$refs.root);
        } else {
            window.addEventListener('resize', this.measure);
        }
        // Trwające alarmy i linia „teraz” przesuwają się same, bez przeładowania.
        this.clock = setInterval(function () {
            _this9.now = Date.now();
        }, 30 * 1000);
    },
    beforeDestroy: function beforeDestroy() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        window.removeEventListener('resize', this.measure);
        window.removeEventListener('mousemove', this.onDragMove);
        window.removeEventListener('mouseup', this.endDrag);
        clearInterval(this.clock);
    }
});

/***/ }),

/***/ 1608:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Modal__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Systems_TooltipSystemStatus_vue__ = __webpack_require__(1656);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_0__components_Modal__["a" /* default */],
        TooltipSystemStatus: __WEBPACK_IMPORTED_MODULE_1__components_Systems_TooltipSystemStatus_vue__["a" /* default */]
    },
    props: {
        callback: {}
    },
    data: function data() {
        return {
            data: {},
            header: '',
            tooltip: false,
            list: []
        };
    },

    methods: {
        getData: function getData() {
            this.list = this.data[this.data.column.field].slice().reverse();

            if (this.data.column.field == 'visits') {
                var max = Math.max.apply(null, this.list);
                var green = 0.6 * max;
                var yellow = 0.3 * max;

                for (var i = 0; i < this.list.length; i++) {

                    if (this.list[i] >= green) {
                        this.list[i] = 0;
                    } else if (this.list[i] >= yellow) {
                        this.list[i] = 1;
                    } else {
                        this.list[i] = 2;
                    }
                }
            } else if (this.data.column.field == 'statusTab') {
                for (var _i = 0; _i < this.list.length; _i++) {
                    this.list[_i] = this.list[_i][0];
                }
            }
        },
        calculateDate: function calculateDate(index, data) {
            var dt = new Date();
            dt = new Date(dt.setDate(dt.getDate() - index));
            var ret = dt.setTime(dt.getTime() - 1 * 60 * 60 * 1000);
            return ret > new Date(data.lastUpdate);
        },
        calculateAlarmOffDate: function calculateAlarmOffDate(index, data) {
            var dt = new Date();
            dt = new Date(dt.setDate(dt.getDate() - index));

            return data.alarmsOffCrfi != undefined && data.alarmsOffCrfi != '0001-01-01T00:00:00' && dt > new Date(data.alarmsOffCrfi) || data.alarmsOffMonitoring != undefined && data.alarmsOffMonitoring != '0001-01-01T00:00:00' && dt > new Date(data.alarmsOffMonitoring);
        },
        openInfo: function openInfo(args, value, index) {
            if (this.callback != undefined) {
                this.callback(this.data, 'INFO', 7 - index, value, args);
            }
        }
    },
    mounted: function mounted() {
        this.getData();
    }
});

/***/ }),

/***/ 1609:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Modal__ = __webpack_require__(1547);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_0__components_Modal__["a" /* default */]
    },
    props: {
        activeObject: {},
        activeDay: {},
        title: {
            type: String,
            required: false,
            default: "Status (" + this.activeDay + " days ago)"
        }
    },
    data: function data() {
        return {
            general: 0,
            blackBox: 0,
            device: 0,
            rapid24: 0,
            photocells: 0,
            pressure: 0,
            database: 0
        };
    },

    methods: {
        computeData: function computeData() {
            var index = this.activeDay;
            this.general = this.activeObject.statusTab[index][1];
            this.blackBox = this.activeObject.statusTab[index][2];
            this.device = this.activeObject.statusTab[index][3];
            this.rapid24 = this.activeObject.statusTab[index][4];
            this.photocells = this.activeObject.statusTab[index][5];
            this.pressure = this.activeObject.statusTab[index][6];
            this.database = this.activeObject.statusTab[index][7];
        }
    },
    mounted: function mounted() {
        this.computeData();
    }
});

/***/ }),

/***/ 1610:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SciChart_vue__ = __webpack_require__(1599);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13c4aa24_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SciChart_vue__ = __webpack_require__(1630);
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SciChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13c4aa24_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SciChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1611:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlarmDayTimeline_vue__ = __webpack_require__(1602);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c13e8afa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlarmDayTimeline_vue__ = __webpack_require__(1640);
function injectStyle (ssrContext) {
  __webpack_require__(1638)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c13e8afa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlarmDayTimeline_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c13e8afa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlarmDayTimeline_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1616:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SciChartMultiple_vue__ = __webpack_require__(1600);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1635f11c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SciChartMultiple_vue__ = __webpack_require__(1633);
function injectStyle (ssrContext) {
  __webpack_require__(1631)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SciChartMultiple_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1635f11c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SciChartMultiple_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1617:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tenor.aa5f34f.gif";

/***/ }),

/***/ 1627:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemAlarmsDetailsModal_vue__ = __webpack_require__(1598);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dd90fe8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SystemAlarmsDetailsModal_vue__ = __webpack_require__(1641);
function injectStyle (ssrContext) {
  __webpack_require__(1628)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6dd90fe8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemAlarmsDetailsModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dd90fe8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SystemAlarmsDetailsModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1628:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1629);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("418e12d0", content, true, {});

/***/ }),

/***/ 1629:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".height-120[data-v-6dd90fe8]{height:calc(80vh - 120px)}.day-timeline-layout[data-v-6dd90fe8]{flex-direction:column;width:85vw;height:80vh}.day-timeline-grid[data-v-6dd90fe8],.day-timeline-layout[data-v-6dd90fe8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column}.day-timeline-grid[data-v-6dd90fe8]{flex-direction:column;-webkit-box-flex:1;-ms-flex:1;flex:1;min-height:220px}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Systems/SystemAlarmsDetailsModal.vue"],"names":[],"mappings":"AACA,6BACI,yBAA2B,CAC9B,AACD,sCAOY,sBAAuB,AAC/B,WAAY,AACZ,WAAa,CAChB,AACD,0EAVI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,yBAA2B,CAiBlC,AAZD,oCAOY,sBAAuB,AAC/B,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,gBAAkB,CACrB","file":"SystemAlarmsDetailsModal.vue","sourcesContent":["\n.height-120[data-v-6dd90fe8] {\n    height: calc(80vh - 120px);\n}\n.day-timeline-layout[data-v-6dd90fe8] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    width: 85vw;\n    height: 80vh;\n}\n.day-timeline-grid[data-v-6dd90fe8] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    min-height: 220px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1630:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"horizontal",staticStyle:{"height":"80vh","width":"90vw"}},[_c('div',{staticStyle:{"width":"100%","margin-right":"10px"},attrs:{"id":'scichart-root-' + _vm.sid}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1631:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1632);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("690358ff", content, true, {});

/***/ }),

/***/ 1632:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "#sciTable.e-grid .e-selectionbackground.e-rowcell{background-color:hsla(0,0%,100%,.05)}#sciTable.e-grid .e-row.whiteText .e-rowcell{color:#fff;font-weight:600;font-size:13px;line-height:16px}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/SciChartMultiple.vue"],"names":[],"mappings":"AACA,kDACI,oCAA4C,CAC/C,AACD,6CACI,WAAY,AACZ,gBAAiB,AACjB,eAAgB,AAChB,gBAAkB,CACrB","file":"SciChartMultiple.vue","sourcesContent":["\n#sciTable.e-grid .e-selectionbackground.e-rowcell {\n    background-color: rgba(255, 255, 255, 0.05);\n}\n#sciTable.e-grid .e-row.whiteText .e-rowcell {\n    color: #fff;\n    font-weight: 600;\n    font-size: 13px;\n    line-height: 16px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1633:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"horizontal",staticStyle:{"height":"80vh","width":"90vw"}},[_c('div',{staticStyle:{"width":"80%","margin-right":"10px"},attrs:{"id":'scichart-root-' + _vm.sid}}),_vm._v(" "),_c('ejs-grid',{ref:'grid-' + _vm.sid,attrs:{"id":"sciTable","width":"20%","height":"100%","selectionSettings":_vm.selectionOptions,"allowTextWrap":true,"textWrapSettings":_vm.wrapSettings,"dataBound":_vm.dataBound,"dataSource":_vm.data,"showBusyIndicator":true,"rowDataBound":_vm.rowDataBound,"rowSelected":_vm.selectionChanged,"rowDeselected":_vm.selectionChanged}},[_c('e-columns',[_c('e-column',{attrs:{"type":"checkbox","width":"50","headerText":"Discontinued","textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"title","headerText":'Alarm type',"textAlign":"Left","width":"130","customAttributes":_vm.customAttributes}})],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1634:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SciChartOneLineAlarms_vue__ = __webpack_require__(1601);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b8ae9dd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SciChartOneLineAlarms_vue__ = __webpack_require__(1637);
function injectStyle (ssrContext) {
  __webpack_require__(1635)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b8ae9dd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SciChartOneLineAlarms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b8ae9dd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SciChartOneLineAlarms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1635:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1636);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("970e9d3c", content, true, {});

/***/ }),

/***/ 1636:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SciChartOneLineAlarms.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1637:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"vertical",staticStyle:{"height":"120px","width":"80vw"}},[_c('div',{staticStyle:{"width":"100%","height":"100%","margin-right":"10px","align-self":"center"},attrs:{"id":'scichart-root-' + _vm.sid}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1638:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1639);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("aaf4d316", content, true, {});

/***/ }),

/***/ 1639:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".adt-root[data-v-c13e8afa]{--adt-s1:#2a78d6;--adt-s2:#eb6834;--adt-s3:#1baf7a;--adt-s4:#eda100;--adt-s5:#e87ba4;--adt-s6:#008300;--adt-s7:#4a3aa7;--adt-s8:#e34948;--adt-other:#8a8f90;--adt-now:#d64545;position:relative;padding:8px 12px 4px;color:var(--text);background:var(--surface);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}html[data-theme=dark] .adt-root[data-v-c13e8afa]{--adt-s1:#3987e5;--adt-s2:#d95926;--adt-s3:#199e70;--adt-s4:#c98500;--adt-s5:#d55181;--adt-s6:#008300;--adt-s7:#9085e9;--adt-s8:#e66767;--adt-other:#7d8c8f;--adt-now:#e66767}.adt-toolbar[data-v-c13e8afa]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;gap:12px}.adt-legend[data-v-c13e8afa]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:6px}.adt-chip[data-v-c13e8afa]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:6px;max-width:280px;padding:3px 10px;border:1px solid var(--border);border-radius:14px;background:var(--surface);color:var(--text-strong);font-size:12px;cursor:pointer}.adt-chip[data-v-c13e8afa]:hover{background:var(--surface-hover)}.adt-chip-off[data-v-c13e8afa]{color:var(--text-muted);text-decoration:line-through}.adt-chip-off .adt-swatch[data-v-c13e8afa]{opacity:.25}.adt-chip-name[data-v-c13e8afa]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.adt-chip-count[data-v-c13e8afa]{color:var(--text-muted);font-variant-numeric:tabular-nums}.adt-swatch[data-v-c13e8afa]{display:inline-block;-webkit-box-flex:0;-ms-flex:none;flex:none;width:10px;height:10px;border-radius:2px}.adt-only-active[data-v-c13e8afa]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;gap:6px;margin:4px 0 0;white-space:nowrap;color:var(--text);cursor:pointer}.adt-only-active[data-v-c13e8afa],.adt-zoom[data-v-c13e8afa]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:12px}.adt-zoom[data-v-c13e8afa]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px;margin:8px 0 2px}.adt-range[data-v-c13e8afa]{font-weight:600;color:var(--text-strong);white-space:pre}.adt-hint[data-v-c13e8afa]{color:var(--text-muted)}.adt-btn[data-v-c13e8afa]{padding:2px 8px;border:1px solid var(--border);border-radius:4px;background:var(--surface);color:var(--text);font-size:12px;cursor:pointer}.adt-btn[data-v-c13e8afa]:hover{background:var(--surface-hover)}.adt-axis[data-v-c13e8afa]{display:block}.adt-tick[data-v-c13e8afa]{stroke:var(--text-muted)}.adt-tick-label[data-v-c13e8afa]{fill:var(--text-muted);font-size:11px;font-variant-numeric:tabular-nums}.adt-cursor-label-bg[data-v-c13e8afa]{fill:var(--text-strong)}.adt-cursor-label[data-v-c13e8afa]{fill:var(--surface);font-size:11px;font-weight:600;font-variant-numeric:tabular-nums}.adt-body[data-v-c13e8afa]{overflow-y:auto;overflow-x:hidden}.adt-body-svg[data-v-c13e8afa]{display:block;cursor:crosshair}.adt-track[data-v-c13e8afa]{fill:var(--surface-muted)}.adt-row-label[data-v-c13e8afa]{fill:var(--text-strong);font-size:12px}.adt-grid[data-v-c13e8afa]{stroke:var(--border);stroke-width:1}.adt-future[data-v-c13e8afa]{fill:var(--surface-hover)}.adt-bar[data-v-c13e8afa]{stroke:var(--surface);stroke-width:1;cursor:pointer}.adt-bar[data-v-c13e8afa]:hover{stroke:var(--text-strong)}.adt-bar-selected[data-v-c13e8afa]{stroke:var(--text-strong);stroke-width:2}.adt-continues[data-v-c13e8afa]{fill:var(--text-muted);font-size:9px;pointer-events:none}.adt-now[data-v-c13e8afa]{stroke:var(--adt-now);stroke-width:2;pointer-events:none}.adt-cursor[data-v-c13e8afa]{stroke:var(--text-muted);stroke-dasharray:3 3;pointer-events:none}.adt-selection[data-v-c13e8afa]{fill:var(--accent);fill-opacity:.15;stroke:var(--accent);pointer-events:none}.adt-now-legend[data-v-c13e8afa]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:6px;margin-top:4px;font-size:11px;color:var(--text-muted)}.adt-now-swatch[data-v-c13e8afa]{display:inline-block;width:2px;height:12px;background:var(--adt-now)}.adt-empty[data-v-c13e8afa]{padding:24px 0;text-align:center;color:var(--text-muted);font-size:13px}.adt-tooltip[data-v-c13e8afa]{position:absolute;z-index:5;width:260px;padding:8px 10px;border:1px solid var(--popover-border);border-radius:6px;background:var(--popover-bg);color:var(--popover-fg);-webkit-box-shadow:var(--popover-shadow);box-shadow:var(--popover-shadow);font-size:12px;pointer-events:none}.adt-tooltip-title[data-v-c13e8afa]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:6px;margin-bottom:4px;font-weight:600}.adt-tooltip-description[data-v-c13e8afa]{margin-bottom:4px;word-break:break-word}.adt-tooltip-row[data-v-c13e8afa]{font-variant-numeric:tabular-nums}.adt-tooltip-muted[data-v-c13e8afa]{color:var(--popover-muted)}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Charts/AlarmDayTimeline.vue"],"names":[],"mappings":"AACA,2BACI,iBAAkB,AAClB,iBAAkB,AAClB,iBAAkB,AAClB,iBAAkB,AAClB,iBAAkB,AAClB,iBAAkB,AAClB,iBAAkB,AAClB,iBAAkB,AAClB,oBAAqB,AACrB,kBAAmB,AAEnB,kBAAmB,AACnB,qBAAsB,AACtB,kBAAmB,AACnB,0BAA2B,AAC3B,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,gBAAkB,CAC7B,AACD,iDACI,iBAAkB,AAClB,iBAAkB,AAClB,iBAAkB,AAClB,iBAAkB,AAClB,iBAAkB,AAClB,iBAAkB,AAClB,iBAAkB,AAClB,iBAAkB,AAClB,oBAAqB,AACrB,iBAAmB,CACtB,AACD,8BACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,QAAU,CACb,AACD,6BACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,OAAS,CACZ,AACD,2BACI,2BAA4B,AAC5B,2BAA4B,AAC5B,oBAAqB,AACrB,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,QAAS,AACT,gBAAiB,AACjB,iBAAkB,AAClB,+BAAgC,AAChC,mBAAoB,AACpB,0BAA2B,AAC3B,yBAA0B,AAC1B,eAAgB,AAChB,cAAgB,CACnB,AACD,iCACI,+BAAiC,CACpC,AACD,+BACI,wBAAyB,AACzB,4BAA8B,CACjC,AACD,2CACI,WAAc,CACjB,AACD,gCACI,gBAAiB,AACjB,mBAAoB,AACpB,sBAAwB,CAC3B,AACD,iCACI,wBAAyB,AACzB,iCAAmC,CACtC,AACD,6BACI,qBAAsB,AACtB,mBAAoB,AAChB,cAAe,AACX,UAAW,AACnB,WAAY,AACZ,YAAa,AACb,iBAAmB,CACtB,AACD,kCACI,2BAA4B,AAC5B,2BAA4B,AAC5B,oBAAqB,AAIrB,QAAS,AACT,eAAgB,AAChB,mBAAoB,AAEpB,kBAAmB,AACnB,cAAgB,CACnB,AACD,6DAVI,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAI5B,cAAgB,CAgBnB,AAZD,2BACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AAId,mBAAoB,AAChB,eAAgB,AACpB,QAAS,AACT,gBAAkB,CAErB,AACD,4BACI,gBAAiB,AACjB,yBAA0B,AAC1B,eAAiB,CACpB,AACD,2BACI,uBAAyB,CAC5B,AACD,0BACI,gBAAiB,AACjB,+BAAgC,AAChC,kBAAmB,AACnB,0BAA2B,AAC3B,kBAAmB,AACnB,eAAgB,AAChB,cAAgB,CACnB,AACD,gCACI,+BAAiC,CACpC,AACD,2BACI,aAAe,CAClB,AACD,2BACI,wBAA0B,CAC7B,AACD,iCACI,uBAAwB,AACxB,eAAgB,AAChB,iCAAmC,CACtC,AACD,sCACI,uBAAyB,CAC5B,AACD,mCACI,oBAAqB,AACrB,eAAgB,AAChB,gBAAiB,AACjB,iCAAmC,CACtC,AACD,2BACI,gBAAiB,AACjB,iBAAmB,CACtB,AACD,+BACI,cAAe,AACf,gBAAkB,CACrB,AACD,4BACI,yBAA2B,CAC9B,AACD,gCACI,wBAAyB,AACzB,cAAgB,CACnB,AACD,2BACI,qBAAsB,AACtB,cAAgB,CACnB,AACD,6BACI,yBAA2B,CAC9B,AACD,0BACI,sBAAuB,AACvB,eAAgB,AAChB,cAAgB,CACnB,AACD,gCACI,yBAA2B,CAC9B,AACD,mCACI,0BAA2B,AAC3B,cAAgB,CACnB,AACD,gCACI,uBAAwB,AACxB,cAAe,AACf,mBAAqB,CACxB,AACD,0BACI,sBAAuB,AACvB,eAAgB,AAChB,mBAAqB,CACxB,AACD,6BACI,yBAA0B,AAC1B,qBAAsB,AACtB,mBAAqB,CACxB,AACD,gCACI,mBAAoB,AACpB,iBAAmB,AACnB,qBAAsB,AACtB,mBAAqB,CACxB,AACD,iCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,QAAS,AACT,eAAgB,AAChB,eAAgB,AAChB,uBAAyB,CAC5B,AACD,iCACI,qBAAsB,AACtB,UAAW,AACX,YAAa,AACb,yBAA2B,CAC9B,AACD,4BACI,eAAgB,AAChB,kBAAmB,AACnB,wBAAyB,AACzB,cAAgB,CACnB,AACD,8BACI,kBAAmB,AACnB,UAAW,AACX,YAAa,AACb,iBAAkB,AAClB,uCAAwC,AACxC,kBAAmB,AACnB,6BAA8B,AAC9B,wBAAyB,AACzB,yCAA0C,AAClC,iCAAkC,AAC1C,eAAgB,AAChB,mBAAqB,CACxB,AACD,oCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,QAAS,AACT,kBAAmB,AACnB,eAAiB,CACpB,AACD,0CACI,kBAAmB,AACnB,qBAAuB,CAC1B,AACD,kCACI,iCAAmC,CACtC,AACD,oCACI,0BAA4B,CAC/B","file":"AlarmDayTimeline.vue","sourcesContent":["\n.adt-root[data-v-c13e8afa] {\n    --adt-s1: #2a78d6;\n    --adt-s2: #eb6834;\n    --adt-s3: #1baf7a;\n    --adt-s4: #eda100;\n    --adt-s5: #e87ba4;\n    --adt-s6: #008300;\n    --adt-s7: #4a3aa7;\n    --adt-s8: #e34948;\n    --adt-other: #8a8f90;\n    --adt-now: #d64545;\n\n    position: relative;\n    padding: 8px 12px 4px;\n    color: var(--text);\n    background: var(--surface);\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\nhtml[data-theme=\"dark\"] .adt-root[data-v-c13e8afa] {\n    --adt-s1: #3987e5;\n    --adt-s2: #d95926;\n    --adt-s3: #199e70;\n    --adt-s4: #c98500;\n    --adt-s5: #d55181;\n    --adt-s6: #008300;\n    --adt-s7: #9085e9;\n    --adt-s8: #e66767;\n    --adt-other: #7d8c8f;\n    --adt-now: #e66767;\n}\n.adt-toolbar[data-v-c13e8afa] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: start;\n        -ms-flex-align: start;\n            align-items: flex-start;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    gap: 12px;\n}\n.adt-legend[data-v-c13e8afa] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    gap: 6px;\n}\n.adt-chip[data-v-c13e8afa] {\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 6px;\n    max-width: 280px;\n    padding: 3px 10px;\n    border: 1px solid var(--border);\n    border-radius: 14px;\n    background: var(--surface);\n    color: var(--text-strong);\n    font-size: 12px;\n    cursor: pointer;\n}\n.adt-chip[data-v-c13e8afa]:hover {\n    background: var(--surface-hover);\n}\n.adt-chip-off[data-v-c13e8afa] {\n    color: var(--text-muted);\n    text-decoration: line-through;\n}\n.adt-chip-off .adt-swatch[data-v-c13e8afa] {\n    opacity: 0.25;\n}\n.adt-chip-name[data-v-c13e8afa] {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n.adt-chip-count[data-v-c13e8afa] {\n    color: var(--text-muted);\n    font-variant-numeric: tabular-nums;\n}\n.adt-swatch[data-v-c13e8afa] {\n    display: inline-block;\n    -webkit-box-flex: 0;\n        -ms-flex: none;\n            flex: none;\n    width: 10px;\n    height: 10px;\n    border-radius: 2px;\n}\n.adt-only-active[data-v-c13e8afa] {\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 6px;\n    margin: 4px 0 0;\n    white-space: nowrap;\n    font-size: 12px;\n    color: var(--text);\n    cursor: pointer;\n}\n.adt-zoom[data-v-c13e8afa] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    gap: 8px;\n    margin: 8px 0 2px;\n    font-size: 12px;\n}\n.adt-range[data-v-c13e8afa] {\n    font-weight: 600;\n    color: var(--text-strong);\n    white-space: pre;\n}\n.adt-hint[data-v-c13e8afa] {\n    color: var(--text-muted);\n}\n.adt-btn[data-v-c13e8afa] {\n    padding: 2px 8px;\n    border: 1px solid var(--border);\n    border-radius: 4px;\n    background: var(--surface);\n    color: var(--text);\n    font-size: 12px;\n    cursor: pointer;\n}\n.adt-btn[data-v-c13e8afa]:hover {\n    background: var(--surface-hover);\n}\n.adt-axis[data-v-c13e8afa] {\n    display: block;\n}\n.adt-tick[data-v-c13e8afa] {\n    stroke: var(--text-muted);\n}\n.adt-tick-label[data-v-c13e8afa] {\n    fill: var(--text-muted);\n    font-size: 11px;\n    font-variant-numeric: tabular-nums;\n}\n.adt-cursor-label-bg[data-v-c13e8afa] {\n    fill: var(--text-strong);\n}\n.adt-cursor-label[data-v-c13e8afa] {\n    fill: var(--surface);\n    font-size: 11px;\n    font-weight: 600;\n    font-variant-numeric: tabular-nums;\n}\n.adt-body[data-v-c13e8afa] {\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n.adt-body-svg[data-v-c13e8afa] {\n    display: block;\n    cursor: crosshair;\n}\n.adt-track[data-v-c13e8afa] {\n    fill: var(--surface-muted);\n}\n.adt-row-label[data-v-c13e8afa] {\n    fill: var(--text-strong);\n    font-size: 12px;\n}\n.adt-grid[data-v-c13e8afa] {\n    stroke: var(--border);\n    stroke-width: 1;\n}\n.adt-future[data-v-c13e8afa] {\n    fill: var(--surface-hover);\n}\n.adt-bar[data-v-c13e8afa] {\n    stroke: var(--surface);\n    stroke-width: 1;\n    cursor: pointer;\n}\n.adt-bar[data-v-c13e8afa]:hover {\n    stroke: var(--text-strong);\n}\n.adt-bar-selected[data-v-c13e8afa] {\n    stroke: var(--text-strong);\n    stroke-width: 2;\n}\n.adt-continues[data-v-c13e8afa] {\n    fill: var(--text-muted);\n    font-size: 9px;\n    pointer-events: none;\n}\n.adt-now[data-v-c13e8afa] {\n    stroke: var(--adt-now);\n    stroke-width: 2;\n    pointer-events: none;\n}\n.adt-cursor[data-v-c13e8afa] {\n    stroke: var(--text-muted);\n    stroke-dasharray: 3 3;\n    pointer-events: none;\n}\n.adt-selection[data-v-c13e8afa] {\n    fill: var(--accent);\n    fill-opacity: 0.15;\n    stroke: var(--accent);\n    pointer-events: none;\n}\n.adt-now-legend[data-v-c13e8afa] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 6px;\n    margin-top: 4px;\n    font-size: 11px;\n    color: var(--text-muted);\n}\n.adt-now-swatch[data-v-c13e8afa] {\n    display: inline-block;\n    width: 2px;\n    height: 12px;\n    background: var(--adt-now);\n}\n.adt-empty[data-v-c13e8afa] {\n    padding: 24px 0;\n    text-align: center;\n    color: var(--text-muted);\n    font-size: 13px;\n}\n.adt-tooltip[data-v-c13e8afa] {\n    position: absolute;\n    z-index: 5;\n    width: 260px;\n    padding: 8px 10px;\n    border: 1px solid var(--popover-border);\n    border-radius: 6px;\n    background: var(--popover-bg);\n    color: var(--popover-fg);\n    -webkit-box-shadow: var(--popover-shadow);\n            box-shadow: var(--popover-shadow);\n    font-size: 12px;\n    pointer-events: none;\n}\n.adt-tooltip-title[data-v-c13e8afa] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 6px;\n    margin-bottom: 4px;\n    font-weight: 600;\n}\n.adt-tooltip-description[data-v-c13e8afa] {\n    margin-bottom: 4px;\n    word-break: break-word;\n}\n.adt-tooltip-row[data-v-c13e8afa] {\n    font-variant-numeric: tabular-nums;\n}\n.adt-tooltip-muted[data-v-c13e8afa] {\n    color: var(--popover-muted);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1640:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"root",staticClass:"adt-root"},[_c('div',{staticClass:"adt-toolbar"},[_c('div',{staticClass:"adt-legend"},_vm._l((_vm.legendTypes),function(t){return _c('button',{key:t.key,class:['adt-chip', { 'adt-chip-off': _vm.hiddenTypes[t.key] }],attrs:{"type":"button","title":t.name},on:{"click":function($event){return _vm.toggleType(t.key)}}},[_c('span',{staticClass:"adt-swatch",style:({ background: t.color })}),_vm._v(" "),_c('span',{staticClass:"adt-chip-name"},[_vm._v(_vm._s(t.name))]),_vm._v(" "),_c('span',{staticClass:"adt-chip-count"},[_vm._v(_vm._s(t.count))])])}),0),_vm._v(" "),_c('label',{staticClass:"adt-only-active"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.onlyActive),expression:"onlyActive"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.onlyActive)?_vm._i(_vm.onlyActive,null)>-1:(_vm.onlyActive)},on:{"change":function($event){var $$a=_vm.onlyActive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.onlyActive=$$a.concat([$$v]))}else{$$i>-1&&(_vm.onlyActive=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.onlyActive=$$c}}}}),_vm._v("\n            "+_vm._s(_vm.$t('TimelineOnlyActive'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"adt-zoom"},[_c('span',{staticClass:"adt-range"},[_vm._v(_vm._s(_vm.rangeLabel))]),_vm._v(" "),(_vm.isZoomed)?[_c('button',{staticClass:"adt-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.pan(-1)}}},[_vm._v("◀ "+_vm._s(_vm.$t('TimelineEarlier')))]),_vm._v(" "),_c('button',{staticClass:"adt-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.pan(1)}}},[_vm._v(_vm._s(_vm.$t('TimelineLater'))+" ▶")]),_vm._v(" "),_c('button',{staticClass:"adt-btn",attrs:{"type":"button"},on:{"click":_vm.zoomOut}},[_vm._v(_vm._s(_vm.$t('TimelineZoomOut')))]),_vm._v(" "),_c('button',{staticClass:"adt-btn",attrs:{"type":"button"},on:{"click":_vm.resetZoom}},[_vm._v(_vm._s(_vm.$t('TimelineWholeDay')))])]:_c('span',{staticClass:"adt-hint"},[_vm._v(_vm._s(_vm.$t('TimelineZoomHint')))])],2),_vm._v(" "),_c('svg',{staticClass:"adt-axis",attrs:{"width":_vm.width,"height":_vm.axisHeight}},[_vm._l((_vm.ticks),function(tick){return _c('g',{key:'t' + tick.t},[_c('line',{staticClass:"adt-tick",attrs:{"x1":tick.x,"x2":tick.x,"y1":_vm.axisHeight - 6,"y2":_vm.axisHeight}}),_vm._v(" "),_c('text',{staticClass:"adt-tick-label",attrs:{"x":tick.x,"y":_vm.axisHeight - 10,"text-anchor":"middle"}},[_vm._v(_vm._s(tick.label))])])}),_vm._v(" "),(_vm.cursor != null)?_c('g',[_c('rect',{staticClass:"adt-cursor-label-bg",attrs:{"x":_vm.cursor.x - 28,"y":0,"width":"56","height":_vm.axisHeight - 6,"rx":"3"}}),_vm._v(" "),_c('text',{staticClass:"adt-cursor-label",attrs:{"x":_vm.cursor.x,"y":_vm.axisHeight - 12,"text-anchor":"middle"}},[_vm._v(_vm._s(_vm.cursor.label))])]):_vm._e()],2),_vm._v(" "),(_vm.rows.length == 0)?_c('div',{staticClass:"adt-empty"},[_vm._v(_vm._s(_vm.$t('TimelineNoAlarms')))]):_c('div',{staticClass:"adt-body",style:({ maxHeight: _vm.maxBodyHeight })},[_c('svg',{ref:"body",staticClass:"adt-body-svg",attrs:{"width":_vm.width,"height":_vm.bodyHeight},on:{"mousedown":_vm.startDrag,"mousemove":_vm.moveCursor,"mouseleave":_vm.leavePlot}},[_vm._l((_vm.rows),function(row){return _c('g',{key:row.key},[_c('rect',{staticClass:"adt-track",attrs:{"x":_vm.labelWidth,"y":row.y,"width":_vm.plotWidth,"height":row.height}}),_vm._v(" "),_c('text',{staticClass:"adt-row-label",attrs:{"x":_vm.labelWidth - 14,"y":row.y + row.height / 2 + 4,"text-anchor":"end"}},[_vm._v(_vm._s(row.label))])])}),_vm._v(" "),_vm._l((_vm.ticks),function(tick){return _c('line',{key:'g' + tick.t,staticClass:"adt-grid",attrs:{"x1":tick.x,"x2":tick.x,"y1":0,"y2":_vm.bodyHeight}})}),_vm._v(" "),_vm._l((_vm.nowRows),function(row){return _c('rect',{key:'f' + row.key,staticClass:"adt-future",attrs:{"x":row.futureX,"y":row.y,"width":_vm.labelWidth + _vm.plotWidth - row.futureX,"height":row.height}})}),_vm._v(" "),_vm._l((_vm.bars),function(bar){return _c('g',{key:bar.key},[_c('rect',{class:['adt-bar', { 'adt-bar-selected': _vm.selectedId != null && bar.id == _vm.selectedId }],style:({ fill: bar.color }),attrs:{"x":bar.x,"y":bar.y,"width":bar.w,"height":_vm.barHeight,"rx":"2"},on:{"mouseenter":function (e) { return _vm.showTooltip(e, bar); },"mousemove":function (e) { return _vm.showTooltip(e, bar); },"mouseleave":_vm.hideTooltip,"mousedown":function($event){$event.stopPropagation();},"click":function($event){$event.stopPropagation();return _vm.$emit('select', bar.id)}}}),_vm._v(" "),(bar.continuesLeft)?_c('text',{staticClass:"adt-continues",attrs:{"x":bar.x - 1,"y":bar.y + _vm.barHeight - 2,"text-anchor":"end"}},[_vm._v("◀")]):_vm._e(),_vm._v(" "),(bar.continuesRight)?_c('text',{staticClass:"adt-continues",attrs:{"x":bar.x + bar.w + 2,"y":bar.y + _vm.barHeight - 2}},[_vm._v("▶")]):_vm._e()])}),_vm._v(" "),_vm._l((_vm.nowLines),function(row){return _c('line',{key:'n' + row.key,staticClass:"adt-now",attrs:{"x1":row.nowX,"x2":row.nowX,"y1":row.y,"y2":row.y + row.height + 2}})}),_vm._v(" "),(_vm.cursor != null)?_c('line',{staticClass:"adt-cursor",attrs:{"x1":_vm.cursor.x,"x2":_vm.cursor.x,"y1":0,"y2":_vm.bodyHeight}}):_vm._e(),_vm._v(" "),(_vm.drag != null && Math.abs(_vm.drag.x2 - _vm.drag.x1) > 2)?_c('rect',{staticClass:"adt-selection",attrs:{"x":Math.min(_vm.drag.x1, _vm.drag.x2),"y":0,"width":Math.abs(_vm.drag.x2 - _vm.drag.x1),"height":_vm.bodyHeight}}):_vm._e()],2)]),_vm._v(" "),(_vm.nowLines.length > 0)?_c('div',{staticClass:"adt-now-legend"},[_c('span',{staticClass:"adt-now-swatch"}),_vm._v(_vm._s(_vm.$t('Now'))+" "+_vm._s(_vm.formatClock(_vm.now, false))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.tooltip != null)?_c('div',{staticClass:"adt-tooltip",style:({ left: _vm.tooltip.left + 'px', top: _vm.tooltip.top + 'px' })},[_c('div',{staticClass:"adt-tooltip-title"},[_c('span',{staticClass:"adt-swatch",style:({ background: _vm.tooltip.bar.color })}),_vm._v("\n            "+_vm._s(_vm.tooltip.bar.typeName)+"\n        ")]),_vm._v(" "),(_vm.tooltip.bar.description)?_c('div',{staticClass:"adt-tooltip-description"},[_vm._v(_vm._s(_vm.tooltip.bar.description))]):_vm._e(),_vm._v(" "),(_vm.rowsBy == 'device')?_c('div',{staticClass:"adt-tooltip-row"},[_vm._v(_vm._s(_vm.tooltip.bar.deviceLabel)),(_vm.tooltip.bar.animal)?[_vm._v(" · "+_vm._s(_vm.tooltip.bar.animal))]:_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"adt-tooltip-row"},[_vm._v("\n            "+_vm._s(_vm.formatMoment(_vm.tooltip.bar.start, _vm.tooltip.bar.withDate))+"\n            "),(_vm.tooltip.bar.isActive)?[_vm._v(" – "+_vm._s(_vm.$t('TimelineOngoing')))]:(_vm.tooltip.bar.end > _vm.tooltip.bar.start)?[_vm._v(" – "+_vm._s(_vm.formatMoment(_vm.tooltip.bar.end, _vm.tooltip.bar.withDate)))]:_vm._e()],2),_vm._v(" "),(_vm.tooltip.bar.end > _vm.tooltip.bar.start)?_c('div',{staticClass:"adt-tooltip-muted"},[_vm._v(_vm._s(_vm.formatDuration(_vm.tooltip.bar.end - _vm.tooltip.bar.start)))]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1641:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.value == 0 && _vm.data.column.field != 'visits')?_c('div',{staticStyle:{"margin":"5px"}},[_c('img',{attrs:{"src":__webpack_require__(1617)}})]):(_vm.data.column.field == 'visits')?_c('div',{staticClass:"pl-4 pt-2 pd-2 pr-4"},[_c('p',[_vm._v(_vm._s(_vm.$t('Visits'))+": "+_vm._s(_vm.obj))])]):(_vm.isDayTimeline)?_c('div',{staticClass:"day-timeline-layout"},[(_vm.timelineAlarms != null)?_c('alarm-day-timeline',{attrs:{"alarms":_vm.timelineAlarms,"day":_vm.day,"selected-id":_vm.selectedAlarmId},on:{"visible-change":_vm.onTimelineVisibleChange,"select":_vm.selectAlarmInGrid}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"day-timeline-grid"},[_c('ejs-grid',{ref:"system_modal_grid",staticStyle:{"position":"relative"},attrs:{"height":"100%","width":"100%","selectionSettings":_vm.selectionOptions,"allowTextWrap":true,"textWrapSettings":_vm.wrapSettings,"dataBound":_vm.dataBound,"rowSelected":_vm.rowSelected,"dataSource":_vm.visibleAlarms,"allowPaging":true,"pageSettings":_vm.pageSettings,"allowFiltering":true,"filterSettings":_vm.filterOptions,"allowSorting":true,"allowMultiSorting":true,"allowPdfExport":true,"allowCsvExport":true,"allowExcelExport":true,"showBusyIndicator":true}},[_c('e-columns',[_c('e-column',{attrs:{"field":"number","headerText":_vm.$t('Unit'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"type","headerText":_vm.$t('Type'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"alarmType","headerText":_vm.$t('AlarmType'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"createDate","headerText":_vm.$t('CreateDate'),"textAlign":"Left","customAttributes":_vm.customAttributes,"filter":_vm.filterMenu,"type":"datetime","format":_vm.dateTimeFormatOptions}}),_vm._v(" "),_c('e-column',{attrs:{"field":"endDate","headerText":_vm.$t('EndDate'),"textAlign":"Left","customAttributes":_vm.customAttributes,"filter":_vm.filterMenu,"type":"datetime","format":_vm.dateTimeFormatOptions}})],1)],1)],1)],1):_c('div',{staticStyle:{"width":"85vw","height":"80vh"}},[_c('sci-chart-one-line-alarms',{staticStyle:{"margin-left":"2.5vw"},attrs:{"dataset":_vm.obj,"initialZoomOut":true,"sid":1,"day":_vm.day,"name":_vm.data.column.field}}),_vm._v(" "),_c('div',{staticClass:"height-120",staticStyle:{"display":"flex","flex-direction":"column","flex":"1"}},[_c('ejs-grid',{ref:"system_modal_grid",staticStyle:{"position":"relative"},attrs:{"height":"100%","width":"100%","selectionSettings":_vm.selectionOptions,"allowTextWrap":true,"textWrapSettings":_vm.wrapSettings,"dataBound":_vm.dataBound,"dataSource":_vm.obj,"allowPaging":true,"pageSettings":_vm.pageSettings,"allowFiltering":true,"filterSettings":_vm.filterOptions,"allowSorting":true,"allowMultiSorting":true,"allowPdfExport":true,"allowCsvExport":true,"allowExcelExport":true,"showBusyIndicator":true}},[_c('e-columns',[_c('e-column',{attrs:{"field":"number","headerText":_vm.$t('Unit'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"type","headerText":_vm.$t('Type'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"alarmType","headerText":_vm.$t('AlarmType'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"createDate","headerText":_vm.$t('CreateDate'),"textAlign":"Left","customAttributes":_vm.customAttributes,"filter":_vm.filterMenu,"type":"datetime","format":_vm.dateTimeFormatOptions}}),_vm._v(" "),_c('e-column',{attrs:{"field":"endDate","headerText":_vm.$t('EndDate'),"textAlign":"Left","customAttributes":_vm.customAttributes,"filter":_vm.filterMenu,"type":"datetime","format":_vm.dateTimeFormatOptions}})],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1656:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TooltipSystemStatus_vue__ = __webpack_require__(1609);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b04b559a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TooltipSystemStatus_vue__ = __webpack_require__(1667);
function injectStyle (ssrContext) {
  __webpack_require__(1665)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b04b559a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TooltipSystemStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b04b559a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TooltipSystemStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1662:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemStatus_vue__ = __webpack_require__(1608);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bf82026_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SystemStatus_vue__ = __webpack_require__(1668);
function injectStyle (ssrContext) {
  __webpack_require__(1663)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6bf82026"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bf82026_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SystemStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1663:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1664);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("27df4406", content, true, {});

/***/ }),

/***/ 1664:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".the-thing[data-v-6bf82026]{border:1px solid #3eae94;height:16px;width:8px;border-radius:2px;background-color:#3cd6b1;cursor:pointer}.the-thing-title[data-v-6bf82026]{font-family:SourceSansProBold,sans-serif;font-size:8px;font-style:normal;font-weight:600;color:#414f51}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Systems/SystemStatus.vue"],"names":[],"mappings":"AACA,4BACI,yBAA0B,AAC1B,YAAa,AACb,UAAW,AACX,kBAAmB,AACnB,yBAA0B,AAC1B,cAAgB,CACnB,AACD,kCACI,yCAA6C,AAC7C,cAAe,AACf,kBAAmB,AACnB,gBAAiB,AACjB,aAAe,CAClB","file":"SystemStatus.vue","sourcesContent":["\n.the-thing[data-v-6bf82026] {\n    border: 1px solid #3EAE94;\n    height: 16px;\n    width: 8px;\n    border-radius: 2px;\n    background-color: #3CD6B1;\n    cursor: pointer;\n}\n.the-thing-title[data-v-6bf82026] {\n    font-family: \"SourceSansProBold\", sans-serif;\n    font-size: 8px;\n    font-style: normal;\n    font-weight: 600;\n    color: #414F51;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1665:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1666);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("275ed762", content, true, {});

/***/ }),

/***/ 1666:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".system-modal[data-v-b04b559a]{z-index:999;display:block}.modal-header[data-v-b04b559a]{background-color:#34758e;width:100%;font-family:SourceSansProBold,sans-serif;font-size:12px;font-style:normal;font-weight:600;color:#fff}.title[data-v-b04b559a]{width:200px;font-family:SourceSansProSemiBold,sans-serif!important;font-weight:700;font-size:14px;margin:0}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Systems/TooltipSystemStatus.vue"],"names":[],"mappings":"AACA,+BACI,YAAa,AACb,aAAe,CAClB,AACD,+BACI,yBAA2B,AAC3B,WAAY,AACZ,yCAA6C,AAC7C,eAAgB,AAChB,kBAAmB,AACnB,gBAAiB,AACjB,UAAa,CAChB,AACD,wBACI,YAAa,AACb,uDAA4D,AAC5D,gBAAkB,AAClB,eAAgB,AAChB,QAAU,CACb","file":"TooltipSystemStatus.vue","sourcesContent":["\n.system-modal[data-v-b04b559a] {\n    z-index: 999;\n    display: block;\n}\n.modal-header[data-v-b04b559a] {\n    background-color:  #34758E;\n    width: 100%;\n    font-family: \"SourceSansProBold\", sans-serif;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 600;\n    color: white;\n}\n.title[data-v-b04b559a] {\n    width: 200px;\n    font-family: 'SourceSansProSemiBold', sans-serif !important;\n    font-weight: bold;\n    font-size: 14px;\n    margin: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1667:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"system-modal flex-container",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.$emit('close')}}},[_c('div',{staticClass:"modal-content vertical",staticStyle:{"width":"280px"}},[_c('div',{staticClass:"modal-header"},[(_vm.title != undefined)?_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(((_vm.$t('Status')) + " " + (_vm.activeObject.systemName) + " (" + (_vm.activeDay == 0 ? _vm.$t('today') : _vm.activeDay + ' ' + _vm.$t('daysAgo')) + ")"))+" ")]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"mdiv"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"modal-slot vertical"},[_c('div',{staticClass:"horizontal",staticStyle:{"border-bottom":"1px solid #E9E9E9","justify-content":"space-between","padding-left":"10px","padding-right":"10px"}},[_c('div',{staticStyle:{"font-weight":"bold","font-size":"14px"}},[_vm._v(" "+_vm._s(_vm.$t('BlackBox'))+" ")]),_vm._v(" "),_c('div',[(_vm.blackBox == 0)?_c('img',{attrs:{"src":__webpack_require__(1569)}}):(_vm.blackBox == 1)?_c('img',{attrs:{"src":__webpack_require__(1570)}}):(_vm.blackBox == 2)?_c('img',{attrs:{"src":__webpack_require__(1571)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"horizontal",staticStyle:{"border-bottom":"1px solid #E9E9E9","justify-content":"space-between","padding-left":"10px","padding-right":"10px"}},[_c('div',{staticStyle:{"font-weight":"bold","font-size":"14px"}},[_vm._v(_vm._s(_vm.$t('Device')))]),_vm._v(" "),_c('div',[(_vm.device == 0)?_c('img',{attrs:{"src":__webpack_require__(1569)}}):(_vm.device == 1)?_c('img',{attrs:{"src":__webpack_require__(1570)}}):(_vm.device == 2)?_c('img',{attrs:{"src":__webpack_require__(1571)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"horizontal",staticStyle:{"border-bottom":"1px solid #E9E9E9","justify-content":"space-between","padding-left":"10px","padding-right":"10px"}},[_c('div',{staticStyle:{"font-weight":"bold","font-size":"14px"}},[_vm._v(_vm._s(_vm.$t('Rapid24h')))]),_vm._v(" "),_c('div',[(_vm.rapid24 == 0)?_c('img',{attrs:{"src":__webpack_require__(1569)}}):(_vm.rapid24 == 1)?_c('img',{attrs:{"src":__webpack_require__(1570)}}):(_vm.rapid24 == 2)?_c('img',{attrs:{"src":__webpack_require__(1571)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"horizontal",staticStyle:{"border-bottom":"1px solid #E9E9E9","justify-content":"space-between","padding-left":"10px","padding-right":"10px"}},[_c('div',{staticStyle:{"font-weight":"bold","font-size":"14px"}},[_vm._v(_vm._s(_vm.$t('Photocells')))]),_vm._v(" "),_c('div',[(_vm.photocells == 0)?_c('img',{attrs:{"src":__webpack_require__(1569)}}):(_vm.photocells == 1)?_c('img',{attrs:{"src":__webpack_require__(1570)}}):(_vm.photocells == 2)?_c('img',{attrs:{"src":__webpack_require__(1571)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"horizontal",staticStyle:{"border-bottom":"1px solid #E9E9E9","justify-content":"space-between","padding-left":"10px","padding-right":"10px"}},[_c('div',{staticStyle:{"font-weight":"bold","font-size":"14px"}},[_vm._v(_vm._s(_vm.$t('Pressure')))]),_vm._v(" "),_c('div',[(_vm.pressure == 0)?_c('img',{attrs:{"src":__webpack_require__(1569)}}):(_vm.pressure == 1)?_c('img',{attrs:{"src":__webpack_require__(1570)}}):(_vm.pressure == 2)?_c('img',{attrs:{"src":__webpack_require__(1571)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"horizontal",staticStyle:{"border-bottom":"1px solid #E9E9E9","justify-content":"space-between","padding-left":"10px","padding-right":"10px"}},[_c('div',{staticStyle:{"font-weight":"bold","font-size":"14px"}},[_vm._v(_vm._s(_vm.$t('Database')))]),_vm._v(" "),_c('div',[(_vm.database == 0)?_c('img',{attrs:{"src":__webpack_require__(1569)}}):(_vm.database == 1)?_c('img',{attrs:{"src":__webpack_require__(1570)}}):(_vm.database == 2)?_c('img',{attrs:{"src":__webpack_require__(1571)}}):_vm._e()])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdiv"},[_c('div',{staticClass:"md"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1668:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"tip",staticStyle:{"width":"96px"}},[_c('div',{staticClass:"horizontal",staticStyle:{"justify-content":"space-between"}},_vm._l((_vm.list),function(day,index){return _c('div',{key:index},[(_vm.data.lastUpdate != undefined && _vm.data.lastUpdate=='0001-01-01T00:00:00')?_c('div',{staticClass:"the-thing",style:('background-color: #AAAAAA; border-color: #7A7A7A; cursor: default;')}):(_vm.calculateAlarmOffDate(7-index, _vm.data))?_c('div',{staticClass:"the-thing",style:('background-color: #f3f3f3; border-color: #e0e0e0; cursor: default;')}):(_vm.calculateDate(7-index, _vm.data))?_c('div',{staticClass:"the-thing",style:('background-color: #AAAAAA; border-color: #7A7A7A; cursor: default;')}):_c('div',{staticClass:"the-thing",style:('background-color: ' + ['#3CD6B1', '#FFBD6D', '#FF6666'][day] + '; border-color: ' + ['#3EAE94', '#C69C65', '#C65F60'][day]),on:{"click":function (args) { return _vm.openInfo(args, day, index); }}})])}),0),_vm._v(" "),_c('div',{staticClass:"horizontal the-thing-title",staticStyle:{"justify-content":"space-between"}},[_c('div',[_vm._v(_vm._s(_vm.$t('7daysAgo')))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('Today')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1722:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__ = __webpack_require__(953);


//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	name: "DevicesSoftwareHistoryModal",
	provide: {
		grid: [__WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["l" /* Sort */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["i" /* Page */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["g" /* Filter */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["m" /* Toolbar */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["k" /* Search */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["b" /* CommandColumn */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["j" /* PdfExport */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["f" /* ExcelExport */]]
	},
	props: {
		device: {
			type: Object,
			required: true
		}
	},
	data: function data() {
		return {
			softHistory: [],
			pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
			sortSettings: {
				columns: [{ field: 'date', direction: 'Descending' }]
			},
			dateTimeFormatOptions: { format: 'yyyy-MM-dd HH:mm:ss', type: 'dateTime' },
			wrapSettings: { wrapMode: "Content" },
			selectionOptions: { type: "Multiple" },
			filterOptions: {
				type: "Menu"
			},
			customAttributes: { class: "customcss" }
		};
	},

	methods: {
		getData: function getData() {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return Object(__WEBPACK_IMPORTED_MODULE_2__api__["_53" /* getSoftwareHistoryForDevice */])(_this.device.id);

							case 2:
								_this.softHistory = _context.sent;

							case 3:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},

		dataBound: function dataBound() {
			this.$refs.grid.autoFitColumns();
		}
	},
	mounted: function () {
		var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							_context2.next = 2;
							return this.getData();

						case 2:
						case "end":
							return _context2.stop();
					}
				}
			}, _callee2, this);
		}));

		function mounted() {
			return _ref.apply(this, arguments);
		}

		return mounted;
	}()
});

/***/ }),

/***/ 1723:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(122);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['systemId', 'deviceId'],
    provide: {
        grid: [__WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["l" /* Sort */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["i" /* Page */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["g" /* Filter */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["m" /* Toolbar */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["k" /* Search */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["b" /* CommandColumn */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["j" /* PdfExport */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["f" /* ExcelExport */]]
    },
    data: function data() {
        return {
            data: [],
            pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
            toolbar: [{ text: this.$t('ClearFilter'), id: 'clear-filters', prefixIcon: 'e-cancel', align: 'Right' }, { text: this.$t('Excelexport'), prefixIcon: 'e-excelexport', align: 'Right', id: 'excel-export' }, { text: this.$t('Pdfexport'), prefixIcon: 'e-pdfexport', align: 'Right', id: 'pdf-export' }, { text: this.$t('Csvexport'), prefixIcon: 'e-csvexport', align: 'Right', id: 'csv-export' }, 'Search'],
            wrapSettings: { wrapMode: "Content" },
            selectionOptions: { type: "Multiple" },
            filterOptions: {
                type: "Menu"
            },
            customAttributes: { class: 'customcss' },
            sortingModes: [],
            dateTimeFormatOptions: { format: 'yyyy-MM-dd HH:mm:ss', type: 'dateTime' }
        };
    },

    methods: {
        getData: function getData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.data = [];
                                _context.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api__["_32" /* getLoadCellDataHistory */])(_this.systemId, _this.deviceId);

                            case 3:
                                _this.data = _context.sent;

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        toolbarClick: function toolbarClick(args) {
            switch (args.item.id) {
                case "pdf-export":
                    this.$refs.grid.pdfExport();
                    break;
                case "csv-export":
                    this.$refs.grid.csvExport();
                    break;
                case "excel-export":
                    this.$refs.grid.excelExport();
                    break;
                case 'clear-filters':
                    this.$refs.grid.clearFiltering();
                    break;
            }
        },
        dataBound: function dataBound() {
            this.$refs.grid.autoFitColumns();
        }
    },
    mounted: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return this.getData();

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function mounted() {
            return _ref.apply(this, arguments);
        }

        return mounted;
    }()
});

/***/ }),

/***/ 1789:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DevicesSoftwareHistoryModal_vue__ = __webpack_require__(1722);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4290904_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DevicesSoftwareHistoryModal_vue__ = __webpack_require__(1792);
function injectStyle (ssrContext) {
  __webpack_require__(1790)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a4290904"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DevicesSoftwareHistoryModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4290904_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DevicesSoftwareHistoryModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1790:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1791);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("5bd777c8", content, true, {});

/***/ }),

/***/ 1791:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"DevicesSoftwareHistoryModal.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1792:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","flex":"1","height":"50vh","width":"50vw"}},[_c('ejs-grid',{ref:"grid",staticStyle:{"position":"relative"},attrs:{"height":"100%","width":"100%","sortSettings":_vm.sortSettings,"selectionSettings":_vm.selectionOptions,"allowTextWrap":false,"textWrapSettings":_vm.wrapSettings,"dataBound":_vm.dataBound,"dataSource":_vm.softHistory,"allowPaging":true,"pageSettings":_vm.pageSettings,"allowFiltering":true,"filterSettings":_vm.filterOptions,"allowSorting":true,"allowMultiSorting":true,"showBusyIndicator":true}},[_c('e-columns',[_c('e-column',{attrs:{"field":"date","headerText":_vm.$t('UpdateDate'),"textAlign":"Left","customAttributes":_vm.customAttributes,"type":"datetime","format":_vm.dateTimeFormatOptions}}),_vm._v(" "),_c('e-column',{attrs:{"field":"fieldName","headerText":_vm.$t('FieldName'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"value","headerText":_vm.$t('Value'),"textAlign":"Left","customAttributes":_vm.customAttributes}})],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1793:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadCellDataModal_vue__ = __webpack_require__(1723);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6056f62_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadCellDataModal_vue__ = __webpack_require__(1796);
function injectStyle (ssrContext) {
  __webpack_require__(1794)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b6056f62"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadCellDataModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6056f62_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadCellDataModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1794:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1795);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("6764d38c", content, true, {});

/***/ }),

/***/ 1795:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"LoadCellDataModal.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1796:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"90vw","height":"80vh","min-width":"1280px"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","flex":"1","height":"80vh","min-width":"1280px"}},[_c('ejs-grid',{ref:"grid",attrs:{"height":"100%","width":"100%","toolbar":_vm.toolbar,"toolbarClick":_vm.toolbarClick,"selectionSettings":_vm.selectionOptions,"allowTextWrap":true,"textWrapSettings":_vm.wrapSettings,"dataBound":_vm.dataBound,"dataSource":_vm.data,"allowPaging":true,"pageSettings":_vm.pageSettings,"allowFiltering":true,"filterSettings":_vm.filterOptions,"allowSorting":true,"allowMultiSorting":true,"allowPdfExport":true,"allowCsvExport":true,"allowExcelExport":true,"showBusyIndicator":true}},[_c('e-columns',[_c('e-column',{attrs:{"field":"updateDate","headerText":_vm.$t('UpdateDate'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"170","type":"datetime","format":_vm.dateTimeFormatOptions}}),_vm._v(" "),_c('e-column',{attrs:{"field":"leftTare","headerText":_vm.$t('LeftTare'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"120"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"leftCalibration","headerText":_vm.$t('LeftCalibration'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"160"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"rightTare","headerText":_vm.$t('RightTare'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"130"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"rightCalibration","headerText":_vm.$t('RightCalibration'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"170"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"tare","headerText":_vm.$t('Tare'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"100"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"calibration","headerText":_vm.$t('Calibration'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"150"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"tareCalibration","headerText":_vm.$t('TareCalibration'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"160"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"version1","headerText":_vm.$t('Version') + ' 1',"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"120"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"version2","headerText":_vm.$t('Version') + ' 2',"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"120"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"version3","headerText":_vm.$t('Version') + ' 3',"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"120"}})],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1863:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Systems_SystemStatus__ = __webpack_require__(1662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Systems_SystemAlarmsDetailsModal_vue__ = __webpack_require__(1627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Modal_vue__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Systems_Devices_DevicesSoftwareHistoryModal__ = __webpack_require__(1789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Devices_LoadCellDataModal__ = __webpack_require__(1793);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var context = null;

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['systemName', 'systemId'],
    components: {
        DevicesSoftwareHistoryModal: __WEBPACK_IMPORTED_MODULE_8__components_Systems_Devices_DevicesSoftwareHistoryModal__["a" /* default */],
        SystemAlarmsDetailsModal: __WEBPACK_IMPORTED_MODULE_6__components_Systems_SystemAlarmsDetailsModal_vue__["a" /* default */],
        Modal: __WEBPACK_IMPORTED_MODULE_7__components_Modal_vue__["a" /* default */],
        LoadCellDataModal: __WEBPACK_IMPORTED_MODULE_9__components_Devices_LoadCellDataModal__["a" /* default */]
    },
    provide: {
        grid: [__WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["l" /* Sort */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["i" /* Page */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["g" /* Filter */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["m" /* Toolbar */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["k" /* Search */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["b" /* CommandColumn */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["j" /* PdfExport */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["f" /* ExcelExport */]]
    },
    data: function data() {
        return {
            data: [],
            activeModal: "NONE",
            activeObject: null,
            activeDay: null,
            activeValue: null,
            activeDeviceId: null,
            pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
            toolbar: [{ text: this.systemName + '\t>', id: 'table-title' }, { text: this.$t('Devices'), id: 'table-device-title' }, { text: this.$t('ClearFilter'), id: 'clear-filters', prefixIcon: 'e-cancel', align: 'Right' }, { text: this.$t('Excelexport'), prefixIcon: 'e-excelexport', align: 'Right', id: 'excel-export' }, { text: this.$t('Pdfexport'), prefixIcon: 'e-pdfexport', align: 'Right', id: 'pdf-export' }, { text: this.$t('Csvexport'), prefixIcon: 'e-csvexport', align: 'Right', id: 'csv-export' }, 'Search'],
            sortSettings: {
                columns: [{ field: 'number', direction: 'Ascending' }]
            },
            wrapSettings: { wrapMode: "Content" },
            selectionOptions: { type: "Multiple" },
            filterOptions: {
                type: "Menu"
            },
            customAttributes: { class: "customcss" },
            StatusTemplate: function StatusTemplate() {
                return {
                    template: {
                        extends: __WEBPACK_IMPORTED_MODULE_5__components_Systems_SystemStatus__["a" /* default */],
                        propsData: {
                            callback: function callback(data, mode, day, value) {
                                context.showModal(data, mode, day, value);
                            }
                        }
                    }
                };
            },
            buttonTemplate: function buttonTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('buttonTemplate', {
                        template: '<button v-on:click="openModal" class="device-software-version-button">{{text}}</button>',
                        data: function data() {
                            return {
                                data: {}
                            };
                        },
                        computed: {
                            text: function text() {
                                return this.data.deviceVersion;
                            }
                        },
                        methods: {
                            openModal: function openModal() {
                                // console.log(this.data)
                                context.showModal(this.data, 'SOFTWAREHISTORY', null, null);
                            }
                        }
                    })
                };
            },
            modeTemplate: function modeTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('modeTemplate', {
                        template: '<div>{{mode}}</div>',
                        data: function data() {
                            return {
                                data: {}
                            };
                        },
                        computed: {
                            mode: function mode() {
                                return ["Normal", "Restricitve", "Free Access"][this.data.mode];
                            }
                        }
                    })
                };
            },
            statusTemplate: function statusTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('statusTemplate', {
                        template: '<div>{{status}}</div>',
                        data: function data() {
                            return {
                                data: {}
                            };
                        },
                        computed: {
                            status: function status() {
                                return this.data.status != null ? ["Up", "Down"][this.data.status] : "-";
                            }
                        }
                    })
                };
            },
            lidTemplate: function lidTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('lidTemplate', {
                        template: '<div>{{status}}</div>',
                        data: function data() {
                            return {
                                data: {}
                            };
                        },
                        computed: {
                            status: function status() {
                                return this.data.lid ? "Open" : "Close";
                            }
                        }
                    })
                };
            },
            tiltTemplate: function tiltTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('tiltTemplate', {
                        template: '<div>{{tilt}}</div>',
                        data: function data() {
                            return {
                                data: {}
                            };
                        },
                        computed: {
                            tilt: function tilt() {
                                return this.data.tilt ? "Open" : "Close";
                            }
                        }
                    })
                };
            },
            calibrationTemplate: function calibrationTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('calibrationTemplate', {
                        template: '<div style="cursor: pointer;" v-on:click="showModal()" id="calibrationId">{{tilt}}</div>',
                        data: function data() {
                            return {
                                data: {}
                            };
                        },
                        computed: {
                            tilt: function tilt() {
                                return this.data.calibration.includes("0001-01-01T01:00:00") ? "-" : this.data.calibration.split("T")[0];
                            }
                        },
                        methods: {
                            showModal: function showModal() {
                                context.showCalibrationModal(this.data);
                            }
                        }
                    })
                };
            },
            initPhotodelayTemplate: function initPhotodelayTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('initPhotodelayTemplate', {
                        template: '<div>{{init}}</div>',
                        data: function data() {
                            return {
                                data: {}
                            };
                        },
                        computed: {
                            init: function init() {
                                return this.data.initPhotodelay + 's';
                            }
                        }
                    })
                };
            },
            photodelayTemplate: function photodelayTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('photodelayTemplate', {
                        template: '<div>{{photodelay}}</div>',
                        data: function data() {
                            return {
                                data: {}
                            };
                        },
                        computed: {
                            photodelay: function photodelay() {
                                return this.data.photodelay + "s";
                            }
                        }
                    })
                };
            }
        };
    },

    methods: {
        getData: function getData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.$store.dispatch('set_loading', true);
                                _context.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api__["_68" /* getSystemDevices */])(_this.systemId);

                            case 3:
                                _this.data = _context.sent;

                                _this.$store.dispatch('set_loading', false);

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        dataBound: function dataBound() {
            this.$refs.grid.autoFitColumns();
        },
        toolbarClick: function toolbarClick(args) {
            switch (args.item.id) {
                case "table-system-title":
                    this.$router.push({
                        name: "systems"
                    });
                    break;
                case "table-device-title":
                    this.getData();
                    break;
                case "pdf-export":
                    this.data.forEach(function (item) {
                        item.photocell.reverse();
                        item.loadcell.reverse();
                        item.connection.reverse();
                        item.visits.reverse();
                        item.errorLogs.reverse();
                    });
                    this.$refs.grid.pdfExport();
                    break;
                case "csv-export":
                    this.data.forEach(function (item) {
                        item.photocell.reverse();
                        item.loadcell.reverse();
                        item.connection.reverse();
                        item.visits.reverse();
                        item.errorLogs.reverse();
                    });
                    this.$refs.grid.csvExport();
                    break;
                case "excel-export":
                    this.data.forEach(function (item) {
                        item.photocell.reverse();
                        item.loadcell.reverse();
                        item.connection.reverse();
                        item.visits.reverse();
                        item.errorLogs.reverse();
                    });
                    this.$refs.grid.excelExport();
                    break;
                case 'clear-filters':
                    this.$refs.grid.clearFiltering();
                    break;
            }
        },
        exportComplete: function exportComplete(args) {
            this.data.forEach(function (item) {
                item.photocell.reverse();
                item.loadcell.reverse();
                item.connection.reverse();
                item.visits.reverse();
                item.errorLogs.reverse();
            });
        },
        showModal: function showModal(obj, mode, day, value) {
            //   console.log(obj, day, mode, value)
            this.activeObject = obj;
            this.activeDay = day;
            this.activeModal = mode;
            this.activeValue = value;
        },
        closeModal: function closeModal(mode) {
            this.activeModal = 'NONE';
            this.activeObject = null;
            this.activeDay = null;
            this.activeValue = null;
            if (mode == 'getData') this.getData();
        },
        showCalibrationModal: function showCalibrationModal(data) {
            this.activeDeviceId = data.id;
            this.activeModal = 'LOADCELLDATA';
        }
    },
    mounted: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            context = this;
                            _context2.next = 3;
                            return this.getData();

                        case 3:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function mounted() {
            return _ref.apply(this, arguments);
        }

        return mounted;
    }()
});

/***/ }),

/***/ 2188:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2189);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("07993253", content, true, {});

/***/ }),

/***/ 2189:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".device-software-version-button{border:1px solid #ddd;padding:5px 10px;background:none}.device-software-version-button:hover{background:#bbb}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/Devices.vue"],"names":[],"mappings":"AACA,gCACC,sBAAuB,AACvB,iBAAkB,AAClB,eAAiB,CACjB,AACD,sCACC,eAAoB,CACpB","file":"Devices.vue","sourcesContent":["\n.device-software-version-button {\n\tborder: 1px #ddd solid;\n\tpadding: 5px 10px;\n\tbackground: none;\n}\n.device-software-version-button:hover {\n\tbackground: #bbbbbb;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2190:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2191);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("19b7730b", content, true, {});

/***/ }),

/***/ 2191:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"Devices.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 2192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-container"},[_c('div',{staticStyle:{"width":"100%","overflow-x":"auto"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","flex":"1","height":"80vh","min-width":"1500px"}},[_c('modal',{attrs:{"showDialog":_vm.activeModal == 'INFO',"title":_vm.activeObject != null ? _vm.activeObject.column.headerText : ''},on:{"close":_vm.closeModal}},[_c('system-alarms-details-modal',{attrs:{"data":_vm.activeObject,"day":_vm.activeDay,"apiMethodName":(_vm.activeObject != null && _vm.activeObject.column.field != 'visits') ? 'getDeviceAlarmFromDay' : 'getVisitsForDay',"value":_vm.activeValue}})],1),_vm._v(" "),_c('modal',{attrs:{"show-dialog":_vm.activeModal === 'SOFTWAREHISTORY',"title":_vm.activeObject != null ? _vm.activeObject.column.headerText : ''},on:{"close":_vm.closeModal}},[_c('devices-software-history-modal',{attrs:{"device":_vm.activeObject}})],1),_vm._v(" "),_c('modal',{attrs:{"showDialog":_vm.activeModal == 'LOADCELLDATA',"title":_vm.activeDeviceId != null ? 'Calibration ' + _vm.systemName : ''},on:{"close":_vm.closeModal}},[_c('load-cell-data-modal',{attrs:{"systemId":_vm.systemId,"deviceId":_vm.activeDeviceId}})],1),_vm._v(" "),_c('ejs-grid',{ref:"grid",staticStyle:{"position":"relative"},attrs:{"height":"100%","width":"100%","toolbar":_vm.toolbar,"toolbarClick":_vm.toolbarClick,"sortSettings":_vm.sortSettings,"selectionSettings":_vm.selectionOptions,"allowTextWrap":true,"textWrapSettings":_vm.wrapSettings,"dataBound":_vm.dataBound,"dataSource":_vm.data,"allowPaging":true,"pageSettings":_vm.pageSettings,"allowFiltering":true,"filterSettings":_vm.filterOptions,"allowSorting":true,"allowMultiSorting":true,"allowPdfExport":true,"allowCsvExport":true,"allowExcelExport":true,"showBusyIndicator":true,"excelExportComplete":_vm.exportComplete,"pdfExportComplete":_vm.exportComplete}},[_c('e-columns',[_c('e-column',{attrs:{"field":"number","headerText":'Number',"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"type","headerText":'Type',"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"mode","headerText":'Mode',"textAlign":"Left","template":_vm.modeTemplate,"customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"deviceVersion","template":_vm.buttonTemplate,"headerText":'Software',"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"status","headerText":'Status',"textAlign":"Left","template":_vm.statusTemplate,"customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"calibration","onClick":"showCalibration","headerText":'Calibration',"textAlign":"Left","template":_vm.calibrationTemplate,"customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"photocell","headerText":'Photocell',"template":_vm.StatusTemplate,"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"loadcell","headerText":'Loadcell',"template":_vm.StatusTemplate,"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"connection","headerText":'Connection',"template":_vm.StatusTemplate,"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"visits","headerText":'Visits',"template":_vm.StatusTemplate,"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"errorLogs","headerText":'Error Logs',"template":_vm.StatusTemplate,"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"lid","headerText":'Lid',"textAlign":"Left","template":_vm.lidTemplate,"customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"tilt","headerText":'Tild',"textAlign":"Left","template":_vm.tiltTemplate,"customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"initPhotodelay","headerText":'Init Photodelay',"textAlign":"Left","template":_vm.initPhotodelayTemplate,"customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"photodelay","headerText":'Photodelay',"textAlign":"Left","template":_vm.photodelayTemplate,"customAttributes":_vm.customAttributes}})],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/10.a9e3b65e5ed30e19e468.js